{
  "Shadow observation": "影子运行",
  "- Profit:": "- 盈利：",
  "--- Wallet Balance metrics ---": "--- 钱包余额指标 ---",
  "(defaults to 1 - Candlechart is at Z=2)": "（默认值为 1，K 线图的 Z 层级为 2）",
  "(Demo)": "（演示）",
  "(in": "（以",
  ") in": "）以",
  "{p0} - {p1} - {p2} trades": "{p0} - {p1} - {p2} 笔交易",
  "{p0} {p1} order for {p2} at {p3}, filled {p4}": "{p0} {p1} 订单：{p2}，价格 {p3}，已成交 {p4}",
  "{p0} <-- not available in this chart": "{p0} ← 此图表不可用",
  "{p0} bars ({p1}%) {p2}": "{p0} 根 K 线（{p1}%）{p2}",
  "{p0} indicator(s) affected by startup candle count": "{p0} 个指标受到启动 K 线数量影响",
  "{p0} pairs": "{p0} 个交易对",
  "* Custom entry tag [optional]": "* 自定义入场标签［可选］",
  "0 bars - 0%": "0 根 K 线 - 0%",
  "404 Error.": "404 错误。",
  "Abort": "中止",
  "Abs $": "绝对收益 $",
  "Account": "账户",
  "Actions": "操作",
  "Actions for {p0}": "{p0} 的操作",
  "Add": "添加",
  "Add all pairs from Pairlist Config - requires the pairlist config to have ran first.": "添加交易对配置中的全部交易对，需要先运行交易对配置评估。",
  "Add indicator": "添加指标",
  "Add indicator to plot": "向图表添加指标",
  "Add new {p0}": "新增 {p0}",
  "Add new {p0}.": "新增 {p0}。",
  "Add new Bot": "添加机器人",
  "Add new value": "添加数值",
  "Add Pair to Blacklist": "将交易对加入黑名单",
  "Advanced options": "高级选项",
  "Advanced options (Erase data, Download trades, and Custom Exchange settings) will only be applied when this section is expanded.": "只有展开此区域后，高级选项（清除数据、下载逐笔成交、自定义交易所）才会生效。",
  "Ahhhhhhhh! The page you are looking for does not exist.": "你访问的页面不存在。",
  "All": "全部",
  "All non-running background jobs cleared": "已清理全部未运行的后台任务",
  "All Trades": "全部交易",
  "All USDT Futures Pairs": "全部 USDT 合约交易对",
  "All USDT Pairs": "全部 USDT 交易对",
  "Allow limit orders": "允许限价单",
  "Allow limit orders in lookahead analysis (could cause false positives in lookahead analysis results).": "在前视偏差分析中允许限价单，可能导致分析结果出现误报。",
  "Amount": "数量",
  "Amount in {p0} [optional]": "数量（{p0}）［可选］",
  "Analysis": "策略分析",
  "Analysis Result": "分析结果",
  "Analyze result": "分析结果",
  "API Url": "API 地址",
  "API URL is required.": "请填写 API 地址。",
  "Apply template": "应用模板",
  "Apply Template": "应用模板",
  "Area chart - Fill to (leave empty for line chart)": "面积图填充目标（留空时使用折线图）",
  "Assumes freqAI configuration is setup in the configuration, and the strategy is a freqAI strategy. Will fail if that's not the case.": "需要在配置中设置 FreqAI，并使用 FreqAI 策略，否则运行会失败。",
  "at": "于",
  "At risk": "风险敞口",
  "Auto Refresh all bots now": "立即刷新全部机器人",
  "Auto refresh for {p0}": "自动刷新 {p0}",
  "Auto Refresh for all bots": "自动刷新全部机器人",
  "Available": "可用",
  "Available bots": "可用机器人",
  "Available results:": "可用结果：",
  "Avg Profit": "平均盈利",
  "Avg Profit %": "平均收益率",
  "Avg. Duration Losers": "亏损交易平均时长",
  "Avg. Duration winners": "盈利交易平均时长",
  "Avg. stake amount": "平均投入金额",
  "Back": "返回",
  "Background sync": "后台同步",
  "Backtest": "回测",
  "Backtest failed: {p0}.": "回测失败：{p0}。",
  "Backtest running:": "回测运行中：",
  "Backtest Time": "回测时间",
  "Backtest-result comparison": "回测结果对比",
  "Backtest-result for": "回测结果：",
  "Backtesting": "策略回测",
  "Backtesting from": "回测开始时间",
  "Backtesting metrics": "回测指标",
  "Backtesting parameters": "回测参数",
  "Backtesting settings": "回测设置",
  "Backtesting summary": "回测概览",
  "Backtesting to": "回测结束时间",
  "Balance": "资产余额",
  "Best day": "最佳交易日",
  "Best Pair": "最佳交易对",
  "Best single Trade": "最佳单笔交易",
  "Biased entry signals": "存在偏差的入场信号",
  "Biased exit signals": "存在偏差的离场信号",
  "Biased indicators": "存在偏差的指标",
  "Bins": "分组数量",
  "Blacklist": "黑名单",
  "Blacklist - Select (followed by a click on '-') to remove pairs": "黑名单：选中交易对后点击“-”移除",
  "Blacklisted Pairs": "黑名单交易对",
  "Bot": "机器人",
  "Bot comparison": "机器人对比",
  "Bot must be in webserver mode to enable Backtesting.": "机器人需要处于 webserver 模式才能运行回测。",
  "Bot name": "机器人名称",
  "Bot Name": "机器人名称",
  "Bot not found": "未找到机器人",
  "Bot start date:": "机器人启动时间：",
  "Breakdown": "分组统计",
  "BT execution time": "回测执行时长",
  "Cache Backtest results:": "缓存回测结果：",
  "Calmar{p0}": "Calmar 比率{p0}",
  "Can reduce the transfer size for large dataframes. May require additional calls if the plot config changes.": "减少大数据表的传输量；修改图表配置后可能需要额外请求。",
  "Cancel": "取消",
  "Cancel open order": "撤销未成交订单",
  "Cancel open orders": "撤销未成交订单",
  "Canceled Entry Orders": "已撤销的入场订单",
  "Canceled open order for {p0}": "已撤销交易 {p0} 的未成交订单",
  "Canceled Trade Entries": "已取消的入场交易",
  "Candle Color Preference": "K 线颜色偏好",
  "Chart": "行情图表",
  "Chart scale Side": "图表刻度位置",
  "Chart settings": "图表设置",
  "Checks your strategy for lookahead bias by comparing signals generated on the full dataset against signals generated on progressively shorter timeranges. Indicators or signals that change depending on future data indicate a lookahead bias that will make backtest results unreliable.": "比较完整数据集与逐步缩短的时间范围生成的信号，检查策略是否存在前视偏差。依赖未来数据而变化的指标或信号会导致回测结果失真。",
  "Checks your strategy's indicators for recursive formula issues by comparing indicator values calculated with different startup candle counts. Indicators that show a difference are likely affected by the amount of startup data and may produce inconsistent results between backtesting and dry/live runs.": "比较不同启动 K 线数量计算的指标值，检查递归公式问题。受启动数据量影响的指标可能造成回测与模拟或实盘交易结果不一致。",
  "Clear end date": "清除结束日期",
  "Clear end time": "清除结束时间",
  "Clear start date": "清除开始日期",
  "Clear start time": "清除开始时间",
  "Click to select all bots": "选择全部机器人",
  "Click to select all dry run bots": "选择全部模拟交易机器人",
  "Click to select all live bots": "选择全部实盘机器人",
  "close": "收盘",
  "Close": "关闭",
  "Close Actions menu": "关闭操作菜单",
  "Close date": "平仓日期",
  "Close rate": "平仓价格",
  "Close Rate": "平仓价格",
  "Close Reason": "平仓原因",
  "Closed Profit": "已平仓盈利",
  "Closed Trades": "已平仓交易",
  "Color": "颜色",
  "Comma separated list of startup candle counts to compare against each other. Leave empty to use the backend defaults.": "输入需要对比的启动 K 线数量，以逗号分隔。留空使用后端默认值。",
  "Compare results": "对比结果",
  "Configure and confirm a forced trade exit": "配置并确认强制离场",
  "Configure chart plot indicators and subplots": "配置图表指标和子图",
  "Confirm": "确认",
  "Confirm dialog deactivated, Forced exits will be executed immediately. Be careful.": "已关闭确认弹窗，强制离场操作将立即执行，请谨慎操作。",
  "Confirm Dialog deactivated.": "已关闭确认弹窗。",
  "Confirmation": "操作确认",
  "Connected to bot, however Login failed, Username or Password wrong.": "已连接机器人，但登录失败，请检查用户名和密码。",
  "Copied!": "已复制！",
  "Copy": "复制",
  "Copy from:": "复制来源：",
  "Count": "次数",
  "Cumulative Profit": "累计盈利",
  "Currency": "币种",
  "Current Exchange:": "当前交易所：",
  "Current profit %": "当前收益率",
  "Current rate": "当前价格",
  "Current Rate": "当前价格",
  "Current stoploss dist": "当前止损距离",
  "Current Value - In futures mode Collateral + PnL": "当前价值；合约模式下为保证金加盈亏",
  "Currently": "当前",
  "Currently owning": "当前持有",
  "Custom data for trade {p0}": "交易 {p0} 的自定义数据",
  "Custom Exchange": "自定义交易所",
  "Custom Stoploss": "自定义止损",
  "Daily": "每日",
  "Daily profit": "每日盈利",
  "Dashboard": "仪表盘",
  "Date": "日期",
  "Day": "日",
  "Days": "天数",
  "Days to download": "下载天数",
  "Days to download:": "下载天数：",
  "Days win/draw/loss": "盈利／持平／亏损天数",
  "Decide if open trades should be visualized": "选择是否在顶部显示持仓数量",
  "Default number of candles to display (defaults to 250)": "默认显示的 K 线数量（默认 250）",
  "Delete bot": "删除机器人",
  "Delete Lock": "删除锁定记录",
  "Delete result": "删除结果",
  "Delete result {p0} from disk?": "确认从磁盘删除结果 {p0}？",
  "Delete this {p0}.": "删除此 {p0}。",
  "Delete this Result from Disk": "从磁盘删除此结果",
  "Delete this value.": "删除此数值。",
  "Delete trade": "删除交易",
  "Deleted Lock {p0}.": "已删除锁定记录 {p0}。",
  "Deleted Trade {p0}": "已删除交易 {p0}",
  "Detail timeframe, to simulate intra-candle results. Not setting this will not use this functionality.": "使用更小的 K 线周期模拟主 K 线内部的价格变化。留空则不使用此功能。",
  "Detail Timeframe:": "精细 K 线周期：",
  "Details": "详情",
  "Direction": "买卖方向",
  "disabled": "已禁用",
  "Don't show open trades in header": "不在顶部显示持仓数量",
  "Don't worry, you can head back to": "可以返回",
  "Download Data": "数据下载",
  "Download Trades instead of OHLCV data": "下载逐笔成交数据",
  "Downloading Data": "历史数据下载",
  "Drawdown duration": "回撤持续时间",
  "Drawdown duration{p0}": "回撤持续时间{p0}",
  "Drawdown end": "回撤结束时间",
  "Drawdown end{p0}": "回撤结束时间{p0}",
  "Drawdown start": "回撤开始时间",
  "Drawdown start{p0}": "回撤开始时间{p0}",
  "Draws": "持平次数",
  "Dry": "模拟",
  "Dry-Run": "模拟交易",
  "Duplicate {p0}.": "复制此 {p0}。",
  "Edit bot": "编辑机器人",
  "Edit this {p0}.": "编辑此 {p0}。",
  "Enable FreqAI:": "启用 FreqAI：",
  "Enable protections": "启用保护机制",
  "Enable Protections:": "启用保护机制：",
  "enabled": "已启用",
  "End Date": "结束日期",
  "End date (yyyy-mm-dd, UTC)": "结束日期（yyyy-mm-dd，UTC）",
  "End time (UTC)": "结束时间（UTC）",
  "Enter Position": "建仓",
  "Enter tag": "入场标签",
  "Enter your bot credentials to connect": "输入机器人登录信息以建立连接",
  "Entries": "入场",
  "Entry Cancel notifications": "入场撤单通知",
  "Entry fill: {p0} {p1} at {p2}": "入场成交：{p0} {p1}，价格 {p2}",
  "Entry notifications": "入场成交通知",
  "Entry order cancelled for {p0} due to {p1}": "交易对 {p0} 的入场订单已取消，原因：{p1}",
  "Entry tag": "入场标签",
  "Entry/Exit timeouts": "入场／离场订单超时",
  "Erase existing data": "清除现有数据",
  "Error calling stopbuy.": "暂停入场失败。",
  "Error occured entering: '{p0}'": "入场失败：“{p0}”",
  "Error occured while adding pairs to Blacklist: '{p0}'": "将交易对加入黑名单失败：“{p0}”",
  "Error occured while removing pairs from Blacklist: '{p0}'": "将交易对移出黑名单失败：“{p0}”",
  "Error reloading.": "重新加载失败。",
  "Error starting bot.": "启动机器人失败。",
  "Error stopping bot.": "停止机器人失败。",
  "Error while adding pair {p0} to Blacklist: {p1}": "将交易对 {p0} 加入黑名单失败：{p1}",
  "Error while removing pair {p0} from Blacklist: {p1}": "将交易对 {p0} 移出黑名单失败：{p1}",
  "Evaluate": "评估",
  "Evaluate pairlist": "评估交易对列表",
  "Evaluation failed": "评估失败",
  "Evaluation returned 0 pairs": "评估未返回任何交易对",
  "Exit Cancel notifications": "离场撤单通知",
  "Exit fill: {p0} {p1} {p2}": "离场成交：{p0} {p1}，价格 {p2}",
  "Exit notifications": "离场成交通知",
  "Exit order cancelled for {p0} due to {p1}": "交易对 {p0} 的离场订单已取消，原因：{p1}",
  "Exit order for {p0} created": "已创建交易 {p0} 的离场订单",
  "Exit Position": "平仓",
  "Exit profit offset": "离场盈利偏移",
  "Exit profit only": "仅盈利时离场",
  "Exit Reason": "离场原因",
  "Exiting Trade #": "正在离场，交易编号 #",
  "Exits": "离场",
  "Expectancy": "期望收益",
  "Expectancy {p0}": "期望收益 {p0}",
  "Failed to cancel open order {p0}": "撤销交易 {p0} 的未成交订单失败",
  "Failed to clear background jobs": "清理后台任务失败",
  "Failed to create exit order for {p0}": "创建交易 {p0} 的离场订单失败",
  "Failed to delete lock {p0}": "删除锁定记录 {p0} 失败",
  "Failed to delete trade {p0}": "删除交易 {p0} 失败",
  "Failed to get background job status": "获取后台任务状态失败",
  "Failed to get custom data for trade {p0}": "获取交易 {p0} 的自定义数据失败",
  "Failed to load data": "加载数据失败",
  "Failed to load Plot configuration from Strategy.": "从策略加载图表配置失败。",
  "Failed to reload trade {p0}": "重新加载交易 {p0} 失败",
  "Failed to run lookahead analysis": "运行前视偏差分析失败",
  "Failed to run recursive analysis": "运行递归分析失败",
  "Fees close": "平仓手续费",
  "Filename": "文件名",
  "Filled": "已成交",
  "Filter": "筛选",
  "Filter results": "筛选结果",
  "Final balance": "期末余额",
  "First trade opened:": "首笔交易开仓时间：",
  "for": "用于",
  "Force enter - Immediately enter a trade at an optional price. Exits are then handled according to strategy rules.": "强制入场：立即建仓，可指定价格。之后按照策略规则处理离场。",
  "Force entering a trade": "强制入场",
  "force entry:": "强制入场：",
  "Force exit all": "全部强制离场",
  "Force exit trade": "强制离场",
  "Force exiting a trade": "强制离场",
  "Forceexit": "强制离场",
  "ForceExit all": "全部强制离场",
  "Forceexit limit": "限价强制离场",
  "Forceexit market": "市价强制离场",
  "Forceexit partial": "部分强制离场",
  "FreqAI identifier:": "FreqAI 标识符：",
  "FreqAI Model:": "FreqAI 模型：",
  "Freqtrade bot Login": "登录 Freqtrade 机器人",
  "Freqtrade CORS documentation": "Freqtrade CORS 配置文档",
  "Freqtrade Documentation": "Freqtrade 使用文档",
  "Freqtrade logo": "Freqtrade 标志",
  "Freqtrade will continue to handle open trades, but will not enter new trades or increase position sizes. Really stop entering?": "机器人将继续管理已有持仓，但不再开仓或加仓。确认暂停入场？",
  "FreqUI Settings": "FreqUI 设置",
  "From strategy": "从策略加载",
  "From template": "从模板加载",
  "Funding fees": "资金费用",
  "Funding Rate": "资金费率",
  "Futures": "合约",
  "Futures/Margin": "合约／保证金",
  "General": "常规",
  "Graph will always show the latest values for the selected strategy.": "图表始终显示所选策略的最新数据。",
  "Green Up/Red Down": "绿涨红跌",
  "Has bias": "存在偏差",
  "Have fun -": "祝使用愉快——",
  "Heikin Ashi": "平均 K 线",
  "Hide": "隐藏",
  "highest": "最高",
  "History": "历史记录",
  "Hourly Profit": "每小时盈利",
  "If you expect to have pairs in your blacklist, please login and make sure the server is running.": "如果已配置黑名单，请登录并确认服务正在运行。",
  "If you need any help, please refer to the": "如需帮助，请参阅",
  "in": "以",
  "in {p0}": "以 {p0} 计价",
  "In {p0}": "以 {p0} 计价",
  "in the title bar.": "图标。",
  "Increase an existing position": "对已有持仓加仓",
  "Increase over initial capital of {p0} {p1}": "相对初始资金 {p0} {p1} 的增长",
  "Increase position": "加仓",
  "Increasing position for {p0}": "对 {p0} 加仓",
  "Index": "序号",
  "Indicator": "指标",
  "Indicators in this plot": "图表中的指标",
  "Initial Stoploss": "初始止损",
  "Interest rate": "利率",
  "Invalid configuration": "配置无效",
  "Invalid Password": "密码无效",
  "Keep background sync running while other bots are selected.": "选择其他机器人时，继续在后台同步。",
  "Last trade opened:": "最近一笔交易开仓时间：",
  "Layouts have been reset.": "已重置布局。",
  "Left": "左侧",
  "Leverage to apply [optional]": "杠杆倍数［可选］",
  "Limit": "限价",
  "Liquidation Price": "强平价格",
  "List Unavailable. Please Login and make sure server is running.": "列表不可用。请登录并确认服务正在运行。",
  "Live": "实盘交易",
  "Load backtest result": "加载回测结果",
  "Load configuration from text box below": "从下方文本框加载配置",
  "Load from string below": "从下方文本加载",
  "Load Historic results from disk. You can click on multiple results to load all of them into freqUI.": "从磁盘加载历史结果。可以选择多个结果，一起加载到 FreqUI。",
  "Load indicator config from template": "从模板加载指标配置",
  "Load Results": "加载结果",
  "Load this Result": "加载此结果",
  "Loading...": "加载中…",
  "Lock dynamic layouts": "锁定动态布局",
  "Lock dynamic layouts, so they cannot move anymore. Can also be set from the navbar at the top.": "锁定后无法拖动布局，也可以在顶部导航栏中设置。",
  "Lock Layout": "锁定布局",
  "Login": "登录",
  "Login again": "重新登录",
  "Login failed": "登录失败",
  "Login info expired, please login again.": "登录信息已过期，请重新登录。",
  "Login to your bot": "登录机器人",
  "Logout": "退出登录",
  "Logout confirmation": "退出登录确认",
  "Logs": "运行日志",
  "long": "做多",
  "Long": "做多",
  "Long / Short": "做多／做空",
  "Long entries:": "做多入场：",
  "Long entry signals": "做多入场信号",
  "Long exit signals": "做多离场信号",
  "Long exit:": "做多离场：",
  "Lookahead analysis": "前视偏差分析",
  "Lookahead Analysis": "前视偏差分析",
  "Lookahead bias detected": "检测到前视偏差",
  "Losing Trades": "亏损交易",
  "Losses": "亏损次数",
  "lowest": "最低",
  "Manually enter a new trade": "手动新建交易",
  "Mark": "标记",
  "Mark Area Z-Index": "图表标记区域 Z 层级",
  "Market": "市价",
  "Market change": "市场涨跌幅",
  "Market change %": "市场涨跌幅 %",
  "markets, with Strategy": "市场，使用策略",
  "Max Consecutive Wins / Loss": "最大连续盈利／亏损次数",
  "Max Drawdown": "最大回撤",
  "Max Drawdown (Account)": "账户最大回撤",
  "Max Drawdown ABS": "最大回撤金额",
  "Max Drawdown abs{p0}": "最大回撤金额{p0}",
  "Max Drawdown{p0}": "最大回撤{p0}",
  "Max open trades": "最大持仓数",
  "Max open trades:": "最大持仓数：",
  "Max Rate": "最高价格",
  "Max. Duration Losers": "亏损交易最长时长",
  "Max. Duration winners": "盈利交易最长时长",
  "Mean profit p-value": "平均盈利 p 值",
  "Metric": "指标",
  "Metrics": "指标",
  "Min Rate": "最低价格",
  "Min. Duration Losers": "亏损交易最短时长",
  "Min. Duration winners": "盈利交易最短时长",
  "Min/Max balance (closed trades)": "最低／最高余额（已平仓交易）",
  "Min/Max balance (wallet balance)": "最低／最高余额（钱包余额）",
  "Minimum number of trades the analysis should run for before evaluating bias.": "评估偏差前，分析至少需要运行的交易笔数。",
  "Minimum trade amount:": "最少交易笔数：",
  "Mix Tag": "组合标签",
  "Modify result notes.": "修改结果备注。",
  "Months": "月",
  "Multi pair": "多交易对",
  "Multi Pane": "多窗口",
  "Name and Password are required.": "请填写用户名和密码。",
  "Needs login": "需要登录",
  "No": "否",
  "No Blacklist Available.": "没有可用黑名单。",
  "No custom data for this trade": "此交易没有自定义数据",
  "No data available": "暂无数据",
  "No historic wallet data available.": "暂无钱包历史数据。",
  "No lookahead bias detected": "未检测到前视偏差",
  "No pair selected": "未选择交易对",
  "No recursive formula issues detected": "未检测到递归公式问题",
  "No strategy selected, can't load plot config.": "未选择策略，无法加载图表配置。",
  "No Trades to show.": "暂无交易。",
  "No trades to show...": "暂无交易…",
  "None of the strategy indicators changed when varying the startup candle count.": "改变启动 K 线数量时，策略指标均保持一致。",
  "Not loaded yet.": "尚未加载。",
  "notes": "备注",
  "Notification Settings": "通知设置",
  "Offline": "离线",
  "Ok": "确定",
  "on": "于",
  "Online": "在线",
  "Only available with limit orders": "仅限价单可用",
  "Only request necessary columns": "仅请求必要的数据列",
  "open": "开盘",
  "Open date": "开仓日期",
  "Open Profit": "持仓浮动盈利",
  "Open rate": "开仓价格",
  "Open Rate": "开仓价格",
  "Open trades": "当前持仓",
  "Open Trades": "当前持仓",
  "Open-Fees": "开仓手续费",
  "Order direction (Long or Short)": "订单方向（做多或做空）",
  "Order for {p0} created.": "已创建 {p0} 的订单。",
  "Orders {p0}": "订单 {p0}",
  "OrderType": "订单类型",
  "Pair": "交易对",
  "Pair {p0} added.": "已添加交易对 {p0}。",
  "Pair {p0} removed.": "已移除交易对 {p0}。",
  "Pair Locks": "交易对锁定记录",
  "Pair Navigation": "交易对导航",
  "Pairlist": "交易对列表",
  "Pairlist Config": "交易对配置",
  "Pairs combined": "交易对汇总",
  "Pairs from template": "从模板选择交易对",
  "Password": "密码",
  "Pause - Stop Entering": "暂停入场",
  "Pause (StopBuy) - Freqtrade will continue to handle open trades, but will not enter new trades or increase position sizes.": "暂停入场：机器人继续管理已有持仓，但不再开仓或加仓。",
  "Performance": "交易表现",
  "Period": "周期",
  "Periodic breakdown": "周期统计",
  "Please also check your bot's CORS configuration:": "请同时检查机器人的 CORS 配置：",
  "Please verify that the bot is running, the Bot API is enabled and the URL is reachable. You can verify this by navigating to {p0}/api/v1/ping to make sure the bot API is reachable": "请确认机器人正在运行、已启用 API，且地址可以访问。可打开 {p0}/api/v1/ping 检查 API 连通性。",
  "Plot config name": "图表配置名称",
  "Plot configurator": "图表配置",
  "Plot Configurator": "图表配置",
  "Position value": "持仓价值",
  "Positive funding_fees -> Trade has gained from fees. Negative funding_fees -> Trade had to pay the fees.": "funding_fees 为正表示获得资金费用，为负表示支付资金费用。",
  "Premium Index": "溢价指数",
  "Prepend data when downloading": "下载更早的数据并追加到现有数据之前",
  "Price": "价格",
  "Price [optional]": "价格［可选］",
  "Profit": "盈利",
  "Profit {p0}": "盈利 {p0}",
  "Profit %": "收益率",
  "Profit at Drawdown start | end": "回撤开始／结束时盈利",
  "Profit at Drawdown start | end{p0}": "回撤开始／结束时盈利{p0}",
  "Profit distribution": "盈利分布",
  "Profit Distribution": "盈利分布",
  "Profit factor": "盈利因子",
  "Profit Factor": "盈利因子",
  "Profit factor:": "盈利因子：",
  "Profit over time {p0}": "周期盈利 {p0}",
  "Profit%": "收益率",
  "Profits for": "盈利统计：",
  "Re-map indicators": "重新映射指标",
  "Realized Profit": "已实现盈利",
  "Really cancel open order for trade {p0} (Pair {p1})?": "确认撤销交易 {p0}（交易对 {p1}）的未成交订单？",
  "Really delete trade {p0} (Pair {p1})?": "确认删除交易 {p0}（交易对 {p1}）？",
  "Really forceexit ALL trades?": "确认强制平仓全部交易？",
  "Really remove (logout) from {p0} ({p1})?": "确认移除并退出登录 {p0}（{p1}）？",
  "Reason": "原因",
  "Recommended startup candle count:": "建议的启动 K 线数量：",
  "Recursive analysis": "递归分析",
  "Recursive Analysis": "递归分析",
  "Red Up/Green Down": "红涨绿跌",
  "Refresh": "刷新",
  "Refresh chart": "刷新图表",
  "Rejected entry signals": "被拒绝的入场信号",
  "Rel %": "相对收益率",
  "Reload": "重新加载",
  "Reload Config": "重新加载配置",
  "Reload Config - reloads configuration including strategy, resetting all settings changed on the fly.": "重新加载配置和策略，并重置运行期间修改的设置。",
  "Reload configuration (including strategy)?": "确认重新加载配置及策略？",
  "Reload Custom Data": "重新加载自定义数据",
  "Reload Logs": "重新加载日志",
  "remaining": "剩余",
  "Remove indicator": "移除指标",
  "Remove indicator to plot": "从图表中移除指标",
  "Replaced Entry Orders": "已替换的入场订单",
  "Reset": "重置",
  "Reset Backtest": "重置回测",
  "Reset dynamic layouts to how they were.": "将动态布局恢复到默认状态。",
  "Reset layout": "重置布局",
  "Reset Layout": "重置布局",
  "Reset to last saved configuration": "恢复上次保存的配置",
  "Results Mixed Tag": "组合标签结果",
  "Results per Enter tag": "按入场标签统计",
  "Results per Exit reason": "按离场原因统计",
  "Results per pair": "按交易对统计",
  "Right": "右侧",
  "Run backtest": "运行回测",
  "Running Freqtrade": "Freqtrade 运行中",
  "Running with": "运行模式：",
  "Save": "保存",
  "Save configuration": "保存配置",
  "Scatter symbol size": "散点符号大小",
  "Scroll to bottom": "滚动到底部",
  "Search...": "搜索…",
  "Select Candle Types": "选择 K 线类型",
  "Select indicator to add": "选择要添加的指标",
  "Select items": "选择项目",
  "Select Pairs": "选择交易对",
  "Select pairs to delete pairs from your blacklist.": "选择需要从黑名单中移除的交易对。",
  "Select pairs to plot": "选择要绘制的交易对",
  "Select Template": "选择模板",
  "Select the timerange with hour/minute precision (in UTC)": "选择时间范围，可精确到小时和分钟（UTC）",
  "Select timeframes": "选择 K 线周期",
  "Select timezone (UTC is recommended as exchanges usually work in UTC)": "选择时区（建议使用 UTC，交易所通常使用 UTC）",
  "Select which metrics should be shown on a per pair / tag basis.": "选择在各交易对或标签结果中显示的指标。",
  "Setting": "设置项",
  "Settings": "设置",
  "Sharpe{p0}": "夏普比率{p0}",
  "short": "做空",
  "Short": "做空",
  "Short entries:": "做空入场：",
  "Short exits:": "做空离场：",
  "Should the scale be displayed on the right or left?": "选择在左侧或右侧显示刻度。",
  "Show": "显示",
  "Show Chart Areas": "显示图表区域",
  "Show configuration for easy transfer to a strategy": "显示配置，方便复制到策略中",
  "Show Confirm Dialog for Trade Exits": "强制离场前显示确认弹窗",
  "Show custom data": "显示自定义数据",
  "Show in title": "在标题中显示",
  "Show open trades in header": "在顶部显示持仓数量",
  "Show pill in icon": "在图标上显示数量徽标",
  "Show Tags in Tooltips": "在提示中显示标签",
  "Show Text on Multi Pane Buttons": "多窗口按钮显示文字",
  "Show text on multi pane buttons. If disabled, only shows images.": "在多窗口按钮上显示文字；关闭时只显示图标。",
  "Show this bot in Dashboard": "在仪表盘中显示此机器人",
  "Shown metrics:": "显示指标：",
  "Single trades": "单笔交易",
  "Sort by:": "排序：",
  "Sortino{p0}": "索提诺比率{p0}",
  "Space {p0}": "参数空间 {p0}",
  "Spinning": "旋转加载动画",
  "Spot": "现货",
  "Stake": "投入资金",
  "Stake amount": "投入金额",
  "Stake amount:": "投入金额：",
  "Stake currency:": "计价币种：",
  "Stake-amount in {p0} [optional]": "投入金额（{p0}）［可选］",
  "Start backtest": "开始回测",
  "Start Date": "开始日期",
  "Start date (yyyy-mm-dd, UTC)": "开始日期（yyyy-mm-dd，UTC）",
  "Start Download": "开始下载",
  "Start lookahead analysis": "开始前视偏差分析",
  "Start recursive analysis": "开始递归分析",
  "Start time (UTC)": "开始时间（UTC）",
  "Start Trading": "开始交易",
  "Start Trading mode": "启动交易模式",
  "Starting balance": "期初余额",
  "Starting capital:": "初始资金：",
  "Startup candle counts:": "启动 K 线数量：",
  "Stop Backtest": "停止回测",
  "Stop Bot": "停止机器人",
  "Stop the bot loop from running?": "确认停止机器人运行循环？",
  "Stop Trading - Also stops handling open trades.": "停止交易，同时停止管理已有持仓。",
  "Stoploss": "止损",
  "Stoploss last updated": "止损最近更新时间",
  "Stoploss on exchange is": "交易所止损状态：",
  "Strategy": "策略",
  "Strategy parameters": "策略参数",
  "Strategy settings": "策略设置",
  "Strategy:": "策略：",
  "Submit": "提交",
  "Supported": "已支持",
  "System Quality Number (SQN)": "系统质量指标（SQN）",
  "Target Plot": "目标图表",
  "Targeted number of trades the analysis tries to reach. Must be greater than or equal to the minimum trade amount.": "分析尝试达到的目标交易笔数，必须大于或等于最少交易笔数。",
  "Targeted trade amount:": "目标交易笔数：",
  "The amount at risk based on the stake amount. This is how much you would lose if the stoploss is hit.": "根据投入资金计算的风险金额，即触发止损时预计损失的金额。",
  "The first entry in the pairlist must be a Generating pairlist, like StaticPairList or VolumePairList.": "交易对列表的第一项必须是生成器，例如 StaticPairList 或 VolumePairList。",
  "the main page": "首页",
  "The strategy produced consistent signals across the analyzed timeranges.": "策略在所分析的时间范围内生成了一致的信号。",
  "The strategy produced different signals depending on the available data. Backtest results for this strategy are likely unreliable.": "策略随可用数据变化生成了不同信号，其回测结果可能不可靠。",
  "The values below show the percentage difference compared to the analysis with the most startup candles. Non-zero values indicate a recursive formula issue.": "以下数值显示与最多启动 K 线的分析结果相比的百分比差异。非零值表示存在递归公式问题。",
  "These settings only apply to the chart view and do not affect the bot's actual configuration or behavior.": "这些设置仅用于图表展示，不影响机器人的实际配置或行为。",
  "This action cannot be undone.": "此操作无法撤销。",
  "This Freqtrade version does not support deleting locks.": "当前 Freqtrade 版本不支持删除锁定记录。",
  "This is taking longer than expected ... Hold on ...": "耗时比预期更长，请稍候…",
  "This page allows you to control your trading bot.": "在这里管理你的交易机器人。",
  "This strategy has no parameters.": "此策略没有可配置参数。",
  "This URL is already in use by another bot.": "此地址已被另一台机器人使用。",
  "This will also show": "标题栏也会显示",
  "Time": "时间",
  "Time Breakdown": "时间分组统计",
  "Time period chart is only available when a single bot is selected and showing absolute profit.": "周期图表仅在选中单个机器人且显示绝对收益时可用。",
  "Time Selection": "时间选择",
  "Timeframe": "K 线周期",
  "Timeframe Detail": "精细 K 线周期",
  "Timeframe:": "K 线周期：",
  "Timerange": "时间范围",
  "Timerange:": "时间范围：",
  "Toggle all bots": "切换全部机器人",
  "Toggle Night Mode": "切换夜间模式",
  "Tot Profit {p0}": "总盈利 {p0}",
  "Tot Profit %": "总收益率",
  "Total Profit": "总盈利",
  "Total profit Long": "做多总盈利",
  "Total profit Short": "做空总盈利",
  "Total signals": "信号总数",
  "Total Stake": "投入资金总额",
  "Total stake amount": "投入资金总额",
  "Total trade volume": "交易总额",
  "Total trades / Daily Avg Trades": "交易总笔数／日均交易笔数",
  "Trade": "交易",
  "Trade Detail": "交易详情",
  "Trade history": "历史交易",
  "Trade Id": "交易编号",
  "Trade Navigation": "交易导航",
  "TradeCount:": "交易笔数：",
  "Trades": "交易",
  "Trades durations": "交易时长",
  "Trades log": "交易记录",
  "Trades Log": "交易记录",
  "Trades, with an average duration of": "笔交易，平均持仓时长为",
  "Trading Mode": "交易模式",
  "Trading volume:": "交易金额：",
  "Trail only when offset is reached": "达到偏移阈值后才启用移动止损",
  "Trailing Stop positive": "移动止损盈利阈值",
  "Trailing stop positive offset": "移动止损触发偏移",
  "Trailing Stoploss": "移动止损",
  "Type": "类型",
  "UI": "界面",
  "UI settings": "界面设置",
  "UI Version:": "界面版本：",
  "Unknown": "未知",
  "Unlimited stake": "不限投入金额",
  "Unload this Result from the UI (will remain on disk)": "从界面卸载此结果，磁盘文件仍保留",
  "Unload this Result from UI.": "从界面卸载此结果。",
  "Unlock Layout": "解锁布局",
  "Unsupported": "未支持",
  "Until": "截至",
  "Use config default": "使用配置默认值",
  "Use confirmation dialogs when force-exiting a trade.": "强制离场时显示确认弹窗。",
  "Use custom timerange": "自定义时间范围",
  "Use Exit Signal": "使用离场信号",
  "Use Heikin Ashi candles": "使用平均 K 线（Heikin Ashi）",
  "Use Heikin Ashi candles in your charts": "在图表中使用平均 K 线（Heikin Ashi）",
  "Use Live Data": "使用实时数据",
  "Use live data from the exchange. Only use if you don't have data downloaded locally.": "从交易所获取实时数据；仅在本地没有已下载数据时使用。",
  "Use Pairs from Pairlist Config": "使用交易对配置中的交易对",
  "Use strategy default": "使用策略默认值",
  "Use template": "使用模板",
  "Use Template": "使用模板",
  "Use the bot's configured stake amount": "使用机器人配置的投入金额",
  "Use time": "指定时间",
  "Username": "用户名",
  "UTC Timezone": "时区",
  "Value": "数值",
  "Version:": "版本：",
  "Visualize result": "结果图表",
  "Visualize summary": "汇总图表",
  "Wallet Balance": "钱包余额",
  "Wallet History": "钱包历史",
  "Weekday": "星期",
  "Weeks": "周",
  "Welcome to the": "欢迎使用",
  "When no candle-type is selected, freqtrade will download the necessary candle types for regular operation automatically.": "未选择 K 线类型时，Freqtrade 将自动下载常规运行所需的 K 线类型。",
  "Whitelist": "白名单",
  "Whitelist Methods": "白名单生成方式",
  "Win Rate": "胜率",
  "Win/Draw/Loss": "盈利／持平／亏损次数",
  "Winning Trades": "盈利交易",
  "Wins": "盈利次数",
  "wishes you the Freqtrade team": "Freqtrade 团队",
  "Worst day": "最差交易日",
  "Worst Pair": "最差交易对",
  "Worst single Trade": "最差单笔交易",
  "WSException: {p0}": "WebSocket 异常：{p0}",
  "Years": "年",
  "Yes": "是",
  "You may need to update your freqtrade version to have historic wallet balance data available.": "需要更新 Freqtrade 版本才能查看钱包历史数据。",
  "Language": "界面语言",
  "Language changes are saved automatically.": "语言选择会自动保存。",
  "No bot selected": "未选择机器人",
  "Drag pairlist here": "将交易对规则拖到这里",
  "Config": "配置",
  "Results": "结果",
  " (wallet balance)": "（钱包余额）",
  "Bot: {p0}": "机器人：{p0}",
  "Notification": "通知",
  "Really exit trade {p0} (Pair {p1}) using a {p2} order?": "确认以{p2}单平仓交易 {p0}（交易对 {p1}）？",
  "Really exit trade {p0} (Pair {p1})?": "确认平仓交易 {p0}（交易对 {p1}）？",
  "Current profit": "当前盈利",
  "Total profit": "总盈利",
  "Realized profit": "已实现盈利",
  "Open since: {p0}": "开仓时间：{p0}",
  "Current profit: {p0}": "当前收益率：{p0}",
  "Available: {p0}": "可用资金：{p0}",
  "Candles": "K 线",
  "Volume": "成交量",
  "Projected profit (incl. unrealized): {p0}": "预计盈利（含未实现盈亏）：{p0}",
  "Profit: {p0}": "盈利：{p0}",
  "plot configuration": "图表配置",
  "pairlist configuration": "交易对配置",
  "ROI closed trades": "已平仓收益率",
  "ROI all trades": "全部交易收益率",
  "Total Trade count": "总交易笔数",
  "Bot started": "机器人启动时间",
  "First Trade opened": "首笔交易开仓时间",
  "Latest Trade opened": "最近交易开仓时间",
  "Win / Loss": "盈利／亏损次数",
  "Expectancy (ratio)": "期望收益（比率）",
  "Avg. Duration": "平均持仓时长",
  "Best performing": "表现最佳交易对",
  "Trading volume": "交易金额",
  "Current Drawdown": "当前回撤",
  "from ": "从 ",
  " to ": " 至 ",
  "since ": "开始于 ",
  "Absolute profit": "绝对收益",
  "Relative profit": "相对收益率",
  "Trade Count": "交易笔数",
  "Trade count": "交易笔数",
  "Wallet history": "钱包历史",
  "All trades": "全部交易",
  "Winning trades": "盈利交易",
  "Losing trades": "亏损交易",
  "Trade duration": "交易时长",
  "Trade durations": "交易时长",
  "outlier": "离群值",
  "Capture start": "数据记录起点",
  "(dry)": "（模拟）",
  "(live)": "（实盘）",
  "(mixed dry and live)": "（包含模拟与实盘）",
  "Long entry": "做多入场",
  "Long exit": "做多离场",
  "Short entry": "做空入场",
  "Short exit": "做空离场",
  "Entry": "入场",
  "Exit": "离场",
  "Summary": "汇总",
  "Login info expired!": "登录信息已过期！",
  "Lookahead analysis failed": "前视偏差分析失败",
  "Recursive analysis failed": "递归分析失败",
  "pair or timeframe not specified": "未指定交易对或 K 线周期",
  "pair or timeframe or timerange not specified": "未指定交易对、K 线周期或时间范围",
  "Timeout exceeded": "请求超时",
  "Error fetching history": "获取历史数据失败",
  "No strategy selected": "未选择策略",
  "Pair is empty": "交易对不能为空",
  "Min": "最小值",
  "Max": "最大值",
  "Median": "中位数",
  "Profit:": "盈利：",
  "Trade count:": "交易笔数：",
  "Enter-tag:": "入场标签：",
  "Order Price:": "订单价格：",
  "Order-Tag:": "订单标签：",
  "Exit-Tag:": "离场标签：",
  "adjustment": "仓位调整",
  " (open)": "（未成交）",
  "combined": "汇总",
  "Best pair:": "最佳交易对：",
  "running": "运行中",
  "stopped": "已停止",
  "reload_config": "重新加载配置中",
  "spot": "现货",
  "futures": "合约",
  "margin": "保证金交易",
  "isolated": "逐仓",
  "cross": "全仓",
  "success": "已完成",
  "failed": "失败",
  "pending": "等待中",
  "pairlist": "交易对评估",
  "download_data": "数据下载",
  "lookahead_analysis": "前视偏差分析",
  "recursive_analysis": "递归分析",
  "TRX strategy research": "TRX 策略研究",
  "One-minute spot data, shared execution anchor and independent principal-lot accounting.": "基于 1m 现货数据，采用共用成交锚点与独立本金批次账本。",
  "Research parameters; zero Earn income": "研究参数 · 回测按零理财收益计算",
  "Numerical defaults are experimental. Ending inventory is valued at market price. Real-account trading and Earn are not active.": "默认数值用于研究；期末持仓按市值估值。真实账户交易与理财尚未启用。",
  "Initial virtual cash (USDT)": "初始虚拟资金（USDT）",
  "Research variant": "研究版本",
  "Fixed periods and quantities": "固定周期与数量",
  "Dynamic thresholds and quantities": "动态门槛与数量",
  "Dynamic thresholds, quantities and periods": "动态门槛、数量与周期",
  "Startup method": "启动方式",
  "Wait for pullback": "等待回撤",
  "Small initial purchase": "先买少量",
  "Candidate periods (minutes)": "候选周期（分钟，逗号分隔）",
  "Start date (UTC)": "开始日期（UTC）",
  "End date inclusive (UTC)": "结束日期（包含，UTC）",
  "Buy threshold (fraction)": "买入基础门槛（0.01 = 1%）",
  "Sell threshold (fraction)": "卖出基础门槛（0.01 = 1%）",
  "Research costs and sizing": "研究费用与交易规模",
  "Buy fee (fraction)": "买入费率（小数）",
  "Sell fee (fraction)": "卖出费率（小数）",
  "Slippage (fraction)": "滑点（小数）",
  "Volatility window (minutes)": "波动窗口（分钟）",
  "Base buy fraction": "基础买入比例",
  "Base sell fraction": "基础卖出比例",
  "Run TRX backtest": "运行 TRX 回测",
  "Available 1m candles": "可用 1m K 线",
  "Saved TRX results": "已保存的 TRX 结果",
  "Select result": "选择结果",
  "Total equity": "总权益",
  "Total net profit": "总净收益",
  "Realized lot profit": "已实现批次利润",
  "Unrealized principal PnL": "本金浮盈亏",
  "Maximum drawdown": "最大回撤",
  "Principal TRX": "TRX 本金数量",
  "Warmup minutes": "预热分钟数",
  "Zero-interest benchmark ending equity": "零理财基准期末权益",
  "Hold TRX": "持有 TRX",
  "Hold cash": "持有现金",
  "Order profit and lot allocations": "订单收益与批次分配",
  "Purchases establish cost. Sales realize profit. Unsold quantities remain unrealized.": "买入形成成本，卖出实现利润；未卖出的数量继续计入浮盈亏。",
  "Time (UTC)": "时间（UTC）",
  "Fee (USDT equivalent)": "手续费（折合 USDT）",
  "Net realized profit": "已实现净利润",
  "Cost established": "形成持仓成本",
  "Lot allocations": "查看批次",
  "Lot": "批次",
  "Allocated cost": "分摊成本",
  "Net proceeds": "净到账",
  "No filled orders in this interval": "该区间没有已成交订单",
  "Remaining principal lots": "剩余本金批次",
  "Unit cost including fees": "含费用单位成本",
  "Live paper execution": "实时模拟执行",
  "Uses current Bitget candles and a virtual portfolio. Pause retains inventory. No exchange orders are sent.": "使用 Bitget 当前行情与虚拟资金。暂停后保留持仓；不会向交易所发送订单。",
  "Start paper execution": "开始模拟",
  "Pause paper execution": "暂停模拟",
  "Anchor": "成交锚点",
  "Buy / sell periods (minutes)": "买入 / 卖出周期（分钟）",
  "Earn and cash management": "理财与现金管理",
  "Real-account Earn remains pending product eligibility, rates, quotas and arrival-rule verification. This backtest uses zero interest; USDGO forecasts require actual bid/ask prices and verified product tiers.": "真实账户理财需核验产品资格、利率、额度与到账规则。当前回测使用零理财收益；USDGO 净收益预测需要实际买卖报价和已核验的阶梯收益。",
  "Total fees": "手续费合计",
  "Cumulative trading turnover (USDT)": "累计交易额（USDT）",
  "C1 one-year buy and sell allocation comparison": "C1 一年买入／卖出比例对比",
  "C1 one-year buy and sell threshold comparison": "C1 一年买入／卖出门槛对比",
  "Reused saved control": "复用已保存的对照结果",
  "Cumulative trading fees (USDT)": "累计手续费（USDT）",
  "After credited rebates": "返佣后净额",
  "Trading turnover sums actual TRX buy and sell execution values. Trading fees show gross exchange charges, with net fees after credited rebates below. Both are in USDT and exclude stablecoin conversions and Earn operations. Missing saved values are shown as a dash.": "累计交易额为 TRX 实际买入成交额＋卖出成交额；累计手续费为交易所实扣费用，下方列出已到账返佣后的净额。两列单位均为 USDT，不含稳定币兑换、理财申购及赎回。历史保存值缺失时显示“—”。",
  "Remaining principal cost": "剩余本金成本",
  "Oldest remaining lot (days)": "最久未卖出批次（天）",
  "Initial cash wait (minutes)": "首次买入前等待（分钟）",
  "Parameters used for this result": "本次结果使用的参数",
  "Decision details": "决策详情",
  "Confirmation period (minutes)": "确认周期（分钟）",
  "Anchor at confirmation": "确认时锚点",
  "Threshold at confirmation": "确认时阈值",
  "Fill count": "成交次数",
  "Available cash": "可立即使用的现金",
  "Market exposure": "市场敞口",
  "Cost occupation": "本金成本占用率",
  "Decision state": "决策状态",
  "Latest closed candle (UTC)": "最近已闭合 K 线（UTC）",
  "warming_up": "指标预热中",
  "waiting_pullback": "等待回调",
  "waiting_profitable_rebound": "等待可盈利反弹",
  "buy_confirmed": "买入条件已确认",
  "sell_confirmed": "卖出条件已确认",
  "insufficient_cash_or_profitable_principal": "资金不足或暂无可盈利本金批次",
  "signal_expired": "信号已过期",
  "paused": "已暂停",
  "recovered_data_waiting_new_signal": "数据补齐，等待新信号",
  "data_or_accounting_error": "数据或记账异常，已暂停",
  "submitted_order_absent_after_expiry": "过期订单已释放预留资金",
  "Previous": "上一页",
  "Next": "下一页",
  "Stopped": "已停止",
  "Resume uses saved paper parameters and inventory. Backtest parameter edits do not reset the paper portfolio.": "恢复模拟时使用已保存的参数与持仓；修改回测参数不会重置模拟账户。",
  "Return": "收益率",
  "Cash": "现金",
  "Side": "方向",
  "Quantity": "数量",
  "Buy": "买入",
  "Sell": "卖出",
  "Fixed periods, thresholds and fractions": "固定周期、门槛与比例",
  "Net fees after credited rebates": "返佣后净手续费",
  "Gross exchange fees": "交易所扣费",
  "Credited fee rebates": "已到账返佣",
  "Pending fee rebates": "待到账返佣",
  "Daily fee rebate: {ratio}%": "每日自返佣：{ratio}%",
  "The exchange deducts the full fee. Research rebates arrive next day at 00:00 Beijing time in USDT. Pending rebates are excluded from equity and available cash.": "交易时先扣全额手续费；研究默认于次日北京时间 00:00 以 USDT 返佣。未到账返佣不计入权益和可用资金。",
  "Exchange buy fee (fraction)": "交易所买入费率（扣费前）",
  "Exchange sell fee (fraction)": "交易所卖出费率（扣费前）",
  "Fee rebate ratio (0.5 = 50%)": "自返佣比例（0.5 = 50%）",
  "Fee rebate {ratio}%": "返佣 {ratio}%",
  "Order profit includes fee refunds credited by the end of this result. Pending refunds do not count as profit.": "订单利润包含截至本次回测结束已到账的费用返还；待到账返佣不计利润。",
  "Compare all three variants on the same interval": "在同一区间比较三种研究版本",
  "Run all three variants for this interval": "运行三版本同区间比较",
  "Same-interval strategy comparison": "同区间策略对比",
  "Saved backtest comparison batches": "已保存的回测对比批次",
  "Same 1m data, virtual capital, startup method, fees, rebates and slippage; only the strategy variant differs.": "使用同一份 1m 数据、本金、启动方式、手续费、返佣和滑点设置，仅研究版本不同。",
  "Individual run history": "单次回测历史",
  "History includes different intervals and test runs. Use the comparison table for fair variant comparisons.": "历史中包含不同区间与功能测试。比较研究版本请使用上方的同区间对比表。",
  "View details": "查看明细",
  "Compared 1m candles": "本组使用的 1m K 线",
  "Research basics": "基本设置",
  "Confirmation timing": "确认周期与预热",
  "Signals and volatility": "买卖门槛与波动反馈",
  "Purchase and sale sizing": "买卖规模",
  "Fees, rebates and slippage": "手续费、返佣与滑点",
  "Execution constraints": "成交约束与尾仓处理",
  "Other recorded parameters": "其他已记录参数",
  "Parameter name": "参数名称",
  "Recorded value": "本次取值",
  "Meaning": "含义",
  "Usage and applicability": "用法与适用范围",
  "Applicable research variants": "适用研究版本",
  "Usage and current status": "用法与本次状态",
  "The applicability column compares all three variants. Conditional parameters require the condition shown below their variant labels; inactive markers refer to this saved result.": "“适用研究版本”一列并排说明三种版本如何使用各参数。“条件使用”须满足该项下方的条件；“本配置未启用”表示本次保存的回测未使用该项。",
  "Fixed variant": "固定",
  "Dynamic sizing variant": "动态数量",
  "Dynamic-period variant": "动态周期",
  "Uses this parameter": "使用",
  "Does not use this parameter": "不使用",
  "Uses this parameter conditionally": "条件使用",
  "Rule version identifier": "规则版本标识",
  "Selects the execution rules": "选择执行规则",
  "Chooses among period tiers": "按档位选择",
  "Uses only the first period": "仅使用第一项",
  "Used for warmup": "用于预热",
  "Used for warmup and volatility": "预热与波动估计",
  "Used for buy sizing and period tiers": "买入规模与周期选择",
  "Used for buy sizing": "动态买入规模",
  "Uses the threshold directly": "直接使用门槛",
  "Uses it as the base threshold": "作为基础门槛",
  "Uses the fraction directly": "直接按比例计算",
  "Uses it as the base fraction": "作为基础比例",
  "Condition: startup must be Small initial purchase.": "条件：启动方式为“先买少量”。",
  "Condition: the fee rebate ratio must be greater than zero.": "条件：返佣比例大于 0。",
  "Variant applicability is not yet documented.": "版本适用范围尚未说明。",
  "Inactive in this configuration": "本配置未启用",
  "These are the parameters saved with this result. Editing the controls above affects a new run, not this historical result. Only recorded fields are listed.": "这里展示本次回测保存的参数。修改上方设置后需重新运行，已有历史结果不会改变；表中仅列出当时实际记录的参数。",
  "Deployable capital B is starting capital plus realized profit in this zero-interest backtest, excluding unrealized gains and losses. Occupation is the larger of TRX market-value share and remaining principal cost divided by B, capped at 100%.": "当前零理财回测中，可部署本金 B = 初始本金 + 已实现净利润，不包含未实现浮盈亏。占用程度取“TRX 市值占总权益比例”和“剩余本金持仓成本 ÷ B”中较大的一项，上限为 100%。",
  "Research rule version": "研究规则版本",
  "Identifies the accounting and execution rules saved with this run.": "标识本次回测使用的记账与执行规则版本。",
  "Use it to distinguish historical rule revisions. It is report metadata, not a buy or sell signal.": "用于区分不同历史规则版本，本身不决定何时买卖。",
  "Initial virtual capital": "初始虚拟本金",
  "The virtual USDT balance at the start of this backtest.": "本次回测开始时的虚拟 USDT 资金。",
  "Change Initial virtual USDT above and run again. Comparisons must use the same starting capital.": "在上方“初始虚拟资金（USDT）”中修改后重新运行。比较研究版本时需使用相同本金。",
  "After warmup, establish the first price anchor and choose whether to buy immediately.": "预热完成后建立首次价格锚点，并决定是否立即买入。",
  "Wait for pullback keeps cash until a buy signal; Small initial purchase uses the initial buy fraction. Change Startup method above.": "“等待回撤”先持有现金，出现买入信号再买；“先买少量”按初始买入比例建仓。在上方“启动方式”中选择。",
  "Fixed uses constant periods, thresholds and fractions. The other variants add dynamic thresholds and sizing, then dynamic periods.": "固定版本使用固定周期、门槛与比例；另外两种版本依次增加动态门槛与数量、动态周期。",
  "View each variant through View details in the comparison table. For a single run, disable the three-variant comparison and choose a variant above.": "通过对比表的“查看明细”切换研究版本。单独运行时，可取消三版本同区间比较，在上方选择一个版本。",
  "Confirmation period candidates": "候选确认周期",
  "Confirmation closes are derived from the 1m data on UTC boundaries. A 1m observation does not always trigger a trading decision.": "从 1m 数据按 UTC 边界确定较长周期的收盘确认时点；每分钟获取行情不代表每分钟都做买卖决策。",
  "Fixed and dynamic sizing use only the first period. Dynamic periods choose buy tiers from this list and a sell tier one step shorter, down to the first period. Edit Candidate periods above.": "固定版本和动态数量版本只用第一项。动态周期版本从列表选择买入档位，卖出选低一档，最低为第一项。在上方“候选周期”中修改。",
  "Volatility estimation window": "波动估计窗口",
  "Estimate volatility from this many past 1m log returns, normalized to an hour. This also determines initial warmup, including in the fixed variant.": "用最近这些分钟的 1m 对数收益率估计波动，并换算成小时尺度；它也决定启动预热长度，固定版本同样需要预热。",
  "A larger window smooths the estimate but reacts more slowly. Change Volatility window under Research costs and sizing.": "窗口越长，估计越平滑，但对新波动反应更慢。在“研究费用与交易规模”的“波动窗口”中修改。",
  "Period relaxation confirmation count": "周期缩短确认次数",
  "A switch to a shorter period requires this many consecutive schedule evaluations requesting a lower tier. A longer period takes effect immediately.": "连续达到这些次调度评估的降档要求后，才切换到更短周期；升到更长周期则立即生效。",
  "This counts schedule evaluations, not minutes or 1m candles. A higher count makes relaxation slower. Set it in the research configuration; there is no page input yet.": "这里计数的是调度评估次数，并非分钟数或 1m K 线根数。数值越大，缩短周期越慢。通过研究配置调整，当前页面暂无输入项。",
  "Base buy pullback threshold": "买入基础回撤门槛",
  "The required price decline from the shared execution anchor. For example, 1.2% requires price at or below 98.8% of the anchor.": "相对共用成交锚点需要下跌的比例。例如 1.2% 表示价格降到锚点的 98.8% 或更低。",
  "Fixed uses this threshold directly; dynamic variants add volatility and occupation adjustments. A higher value requires a deeper pullback. Edit Buy threshold above.": "固定版本直接使用该门槛；动态版本还叠加波动和资金占用反馈。数值越大，需等待更深回撤。在上方“买入基础门槛”中修改。",
  "Base sell rebound threshold": "卖出基础反弹门槛",
  "The required price rise from the shared execution anchor. Eligible principal lots must also pass the separate profit check.": "相对共用成交锚点需要上涨的比例。准备卖出的本金批次还必须通过独立的盈利检查。",
  "Fixed uses this threshold directly; dynamic variants adjust it. A higher value requires a larger rebound. Edit Sell threshold above.": "固定版本直接使用该门槛；动态版本会调整。数值越大，需等待更大反弹。在上方“卖出基础门槛”中修改。",
  "Dynamic threshold lower bound": "动态门槛下限",
  "The lowest permitted buy or sell threshold after dynamic adjustments.": "动态调整后，买入和卖出门槛允许的最低值。",
  "Increasing it prevents small price moves from triggering trades. It must not exceed the upper bound. Set it in the research configuration.": "调高可避免太小的涨跌触发交易，且不能高于上限。通过研究配置调整。",
  "Dynamic threshold upper bound": "动态门槛上限",
  "The highest permitted buy or sell threshold after dynamic adjustments.": "动态调整后，买入和卖出门槛允许的最高值。",
  "Decreasing it caps how far volatility can raise the threshold. It must not fall below the lower bound. Set it in the research configuration.": "调低可限制波动把门槛抬高的幅度，且不能低于下限。通过研究配置调整。",
  "High volatility reference": "高波动参考值",
  "An hourly-equivalent volatility reference, not a price-change trigger. Dynamic buy sizing uses current volatility divided by this value.": "换算为小时尺度的波动参考值，不是涨跌触发门槛。动态买入规模会使用“当前波动 ÷ 此参考值”。",
  "A lower reference reduces dynamic purchases at the same volatility. In dynamic periods, reaching it also raises the desired period tier by one. Set it in the research configuration.": "相同波动下，参考值越低，动态买入越少。动态周期版本中，达到它还会把期望周期提高一档。通过研究配置调整。",
  "Volatility threshold coefficient": "波动门槛系数",
  "Multiplies volatility scaled to the selected confirmation period before adding it to the buy and sell thresholds.": "将波动换算到所选确认周期后，乘以该系数，再加入买入和卖出门槛。",
  "A larger coefficient requires larger price moves in volatile markets; zero removes this threshold term. It does not disable dynamic sizing. Set it in the research configuration.": "系数越大，波动市场中要求的涨跌幅越大；设为 0 可去掉这项门槛反馈，动态数量逻辑仍保留。通过研究配置调整。",
  "Buy occupation coefficient": "买入占用反馈系数",
  "Adds coefficient × occupation to the buy threshold, slowing additions as more capital is tied up.": "将“系数 × 占用程度”加到买入门槛上，资金占用越高，继续加仓越谨慎。",
  "A larger coefficient requires a deeper pullback at the same occupation. The final threshold still respects its bounds. Set it in the research configuration.": "相同占用程度下，系数越大，要求的回撤越深；最终门槛仍受上下限约束。通过研究配置调整。",
  "Sell occupation coefficient": "卖出占用反馈系数",
  "Subtracts coefficient × occupation from the sell threshold, allowing an earlier rebound sale at high occupation.": "从卖出门槛减去“系数 × 占用程度”，占用越高，越容易在较小反弹时卖出。",
  "A larger coefficient lowers the sell signal threshold, but never bypasses the per-lot profit check. Set it in the research configuration.": "系数越大，卖出信号门槛越低，但仍需逐批满足盈利条件。通过研究配置调整。",
  "The base purchase budget is this fraction of deployable capital B, capped by free cash. It is not a fraction of remaining cash.": "以可部署本金 B 的这一比例作为基础买入预算，同时不超过可用现金；不是按剩余现金计算比例。",
  "Dynamic variants further adjust the budget for pullback depth, occupation and volatility. Price, fees and rounding determine TRX quantity. Change Base buy fraction under Research costs and sizing.": "动态版本还根据回撤深度、占用和波动调整预算，再由价格、手续费及精度确定 TRX 数量。在“研究费用与交易规模”的“基础买入比例”中修改。",
  "The base target is this fraction of current principal TRX, excluding retained interest TRX.": "以当前 TRX 本金数量的这一比例作为基础卖出目标，不包含保留的 TRX 利息。",
  "Dynamic variants add 0.4 × occupation, capped at 100%. Profitable lot availability can reduce the sale; tail completion can increase it. Change Base sell fraction under Research costs and sizing.": "动态版本再加“0.4 × 占用程度”，上限 100%。可盈利批次数量可能让实际卖出减少，尾仓补齐可能让它增加。在“研究费用与交易规模”的“基础卖出比例”中修改。",
  "Initial purchase fraction": "初始买入比例",
  "The fraction of deployable capital B used for the first small purchase after warmup, capped by free cash.": "预热后首次少量建仓使用可部署本金 B 的比例，同时不超过可用现金。",
  "Used only with Small initial purchase and without the ordinary dynamic buy factor. Select that startup method above; set this fraction in the research configuration.": "仅“先买少量”启动方式使用，首次买入不乘普通动态买入因子。启动方式在上方选择，比例通过研究配置调整。",
  "Gross buy fee rate": "买入原始费率",
  "The full fee deducted when buying, before any rebate. It enters both cash usage and principal cost.": "买入时先扣取的全额手续费率，尚未减去返佣；同时计入现金支出与本金成本。",
  "Enter the gross exchange rate under Research costs and sizing. Do not halve it again for a 50% rebate; the rebate ratio is applied separately.": "在“研究费用与交易规模”中填写交易所原始费率。50% 返佣会另行计算，不应把这里再减半。",
  "Gross sell fee rate": "卖出原始费率",
  "The full fee deducted when selling, before any rebate. It affects net proceeds and the per-lot profit check.": "卖出时先扣取的全额手续费率，尚未减去返佣；影响净到账与逐批盈利检查。",
  "Enter the gross exchange rate under Research costs and sizing. Future rebates cannot qualify an otherwise losing sale.": "在“研究费用与交易规模”中填写交易所原始费率。未来返佣不能让当前亏损批次提前满足卖出条件。",
  "Fee self-rebate ratio": "手续费自返佣比例",
  "The share of paid fees returned as simulated USDT at daily settlement. Pending refunds are excluded from equity and free cash.": "已付手续费中，按日结算返还为模拟 USDT 的比例。未到账返佣不计权益和可用现金。",
  "For example, a 0.1% gross fee and 50% rebate give a 0.05% net fee after settlement. Set zero for no rebate. Change Fee rebate ratio under Research costs and sizing.": "例如原始费率 0.1%、返佣 50%，到账后净费率为 0.05%。设为 0 表示无返佣。在“研究费用与交易规模”的“自返佣比例”中修改。",
  "Daily rebate settlement time": "每日返佣结算时间",
  "The daily settlement hour in the configured rebate timezone. A fee refund is credited at the next occurrence of this hour after the fill.": "按返佣时区计算的每日结算小时。成交产生的返佣在成交后下一个该时点到账。",
  "00:00 means the next local midnight. Changing the hour changes when refunded funds become available. Set it in the research configuration.": "00:00 表示下一个当地午夜。修改时点会改变返佣资金何时可用。通过研究配置调整。",
  "Rebate settlement timezone": "返佣结算时区",
  "A fixed offset from UTC used to calculate rebate settlement. UTC+08:00 corresponds to Beijing time.": "用于计算返佣结算时间的固定 UTC 偏移。UTC+08:00 对应北京时间。",
  "This affects rebate timing only; candle and order timestamps remain displayed in UTC. Set it in the research configuration.": "它仅影响返佣时间，不改变 K 线和订单仍以 UTC 展示的时间。通过研究配置调整。",
  "Simulated execution slippage": "模拟成交滑点",
  "Buy fills use the next 1m open plus this percentage; sell fills use the next 1m open minus it.": "买入按下一根 1m K 线开盘价上浮该比例成交；卖出则下浮该比例。",
  "A larger value simulates worse fills and may cancel signals that no longer pass execution checks. It is separate from fees. Change Slippage under Research costs and sizing.": "数值越大，模拟成交越不利，也可能使信号无法通过执行复核而取消；滑点与手续费分别计算。在“研究费用与交易规模”的“滑点”中修改。",
  "Minimum order value": "最小订单金额",
  "The minimum quantity × price value for a simulated order, before fees.": "模拟订单“数量 × 价格”的最低金额，不含手续费。",
  "Smaller orders are skipped. This also helps identify untradable tails. Match the intended market rules in the research configuration.": "不足该金额的订单跳过，也用于判断无法单独交易的尾仓。通过研究配置匹配目标市场规则。",
  "Minimum order quantity": "最小订单数量",
  "The minimum TRX quantity for a simulated order. Zero means no additional quantity floor; the minimum order value still applies.": "模拟订单的最低 TRX 数量。0 表示不另设数量下限，但最小订单金额仍有效。",
  "Orders must satisfy both the quantity and value limits. Match the intended market rules in the research configuration.": "订单须同时满足数量与金额要求。通过研究配置匹配目标市场规则。",
  "TRX quantity decimal places": "TRX 数量小数位",
  "Order quantities are rounded down to this many decimal places, never rounded up.": "订单数量保留这些位小数，并向下截取，不向上取整。",
  "Fewer decimal places can leave more dust or bring an order below the minimum value. Match the intended market precision in the research configuration.": "小数位越少，可能留下更多零头，或让订单低于最小金额。通过研究配置匹配目标市场精度。",
  "Per-lot profit buffer": "逐批盈利安全余量",
  "A sale requires price after the gross sell fee to exceed that lot’s unit cost multiplied by one plus this buffer.": "卖出时，扣除原始卖出费率后的单位到账价，必须严格高于该批单位成本 ×（1 + 此余量）。",
  "This is a profitability buffer, not an extra fee. Increasing it requires more profit before selling; zero still requires a strictly profitable sale. Set it in the research configuration.": "它是盈利检查缓冲，不会额外扣费。调高需更多利润才能卖出；设为 0 仍要求严格盈利。通过研究配置调整。",
  "Maximum execution price deviation": "最大成交价格偏离",
  "The maximum absolute percentage difference between the simulated fill price and the signal price.": "模拟成交价相对信号价的百分比偏离绝对值上限。",
  "An order is canceled if the difference exceeds this limit. A smaller value is stricter; zero requires identical prices, rather than disabling the check. Set it in the research configuration.": "超过上限则取消订单。数值越小越严格；0 要求两价相同，不代表关闭检查。通过研究配置调整。",
  "Profitable tail completion": "盈利尾仓补齐",
  "If a normal sale would leave a small untradable principal tail, attempt to sell all free principal in that sale.": "若普通按比例卖出会留下无法单独交易的小额本金尾仓，尝试在本次卖出中补齐全部可用本金数量。",
  "Completion requires every affected lot to pass the profit check. Losing principal and retained interest are not cleared. Disable it to keep the usual proportional sale. Set it in the research configuration.": "只有涉及的所有批次均通过盈利检查才补齐；亏损本金和保留利息继续持有。关闭后维持通常的按比例卖出。通过研究配置调整。",
  "Enabled": "已启用",
  "Disabled": "已关闭",
  "1 minute": "1 分钟",
  "1 hour": "1 小时",
  "{count} hours": "{count} 小时",
  "{count} minutes": "{count} 分钟",
  "{value} coefficient": "{value}（系数）",
  "{value} (+{points} percentage points at full occupation)": "{value}（满占用时加 {points} 个百分点）",
  "{value} (−{points} percentage points at full occupation)": "{value}（满占用时减 {points} 个百分点）",
  "{count} consecutive schedule evaluations": "连续 {count} 次调度评估",
  "{count} decimal places": "{count} 位小数",
  "The fixed variant does not use dynamic adjustments.": "固定版本不使用动态反馈。",
  "Only the dynamic-period variant changes period tiers.": "仅动态周期版本会切换周期档位。",
  "Wait for pullback does not make an initial purchase.": "等待回撤方式不进行首次少量建仓。",
  "The recorded rebate ratio is zero.": "本次记录的返佣比例为 0。",
  "This saved parameter has no description in this frontend version.": "当前前端版本尚未提供该已保存参数的说明。",
  "Its recorded value is shown unchanged. Check the matching research rule version before interpreting it.": "按原样展示已记录的取值，需结合对应研究规则版本理解。",
  "Historical Earn assumptions": "历史理财研究假设",
  "Historical Earn model": "历史理财模型",
  "APR": "年化利率",
  "No Earn": "不计理财收益",
  "Hourly TRX interest only": "仅 TRX 小时理财",
  "Simplified hourly TRX and USDGO interest": "TRX / USDGO 简化小时理财",
  "TRX APR (%)": "TRX 年化利率（%）",
  "USDGO APR (%)": "USDGO 年化利率（%）",
  "TRX research APR": "TRX 研究年化利率",
  "USDGO research APR": "USDGO 研究年化利率",
  "Historical strategy and Earn research": "历史策略与理财研究",
  "TRX APR {trx}%": "TRX 年化 {trx}%",
  "TRX APR {trx}% / USDGO APR {usdgo}%": "TRX 年化 {trx}% / USDGO 年化 {usdgo}%",
  "Fixed research APRs, not verified historical rates. Subscribe immediately, start accruing next UTC hour, then pay after a complete hour. Reinvestment has the same delay; redeemed quantities lose the incomplete hour.": "年化利率为固定研究假设，不是已核验的历史产品利率。模拟即时申购，下一 UTC 整点起息，再经过完整一小时派息。利息复投同样等待；当小时赎回的数量不计该小时收益。",
  "Simplified USDGO: idle funds convert at 1:1, with zero FX fees, unlimited eligibility and instant redemption. Existing TRX buy signals take priority. No real-account operation is performed.": "USDGO 简化口径：闲置资金按 1:1 兑换，兑换费用为 0，不设产品额度限制，赎回及换回即时完成；已有 TRX 买入信号优先。不会操作真实账户。",
  "Earn model used by this batch": "本批次使用的理财口径",
  "Earn assumptions used by this result": "本次结果的理财口径",
  "Total equity includes credited Earn once. TRX interest is retained separately and is not sold with principal. USDGO credits enter deployable capital. The rates and conversion terms are simulated assumptions.": "总权益已包含到账理财收益，不再额外叠加。TRX 利息独立留存，不随本金卖出；USDGO 已到账利息加入可部署资金。利率及兑换条件均为模拟研究假设。",
  "This saved result has zero Earn income. Change the settings above and rerun to obtain a new result; saved historical returns remain unchanged.": "该历史结果未计算理财收益。修改上方设置后需重新运行，新结果另行保存，已有历史收益不变。",
  "Retained TRX interest (TRX)": "留存 TRX 利息（TRX）",
  "TRX interest value at credit (USDT)": "TRX 利息到账时价值（USDT）",
  "Retained TRX interest ending value (USDT)": "TRX 利息期末市值（USDT）",
  "Retained interest price PnL (USDT)": "留存利息价格盈亏（USDT）",
  "USDGO balance": "USDGO 余额",
  "Credited USDGO interest (USDGO)": "已到账 USDGO 利息（USDGO）",
  "Earn income (TRX at ending price)": "理财收益（TRX 按期末价）",
  "Benchmark ending equity with the same Earn assumptions": "相同理财假设下的基准期末权益",
  "Simulated hourly interest credits": "模拟小时派息明细",
  "Each row is a simulated credited payment. Eligible quantity excludes subscriptions that have not started accruing. Retained TRX interest remains exposed to TRX prices; credit-time value and ending market value can differ.": "每行是一笔模拟已到账派息。计息数量不含尚未起息的申购。留存 TRX 利息继续承担币价波动，因此到账时价值可能与期末市值不同。",
  "Eligible interest quantity": "有效计息数量",
  "Credited interest quantity": "到账利息数量",
  "Credit-time value (USDT)": "到账时价值（USDT）",
  "No hourly interest credits in this interval": "该区间暂无小时派息到账",
  "Historical Earn now supports the explicitly selected research scenario. Real-account Earn remains disabled; actual product eligibility, rates, quotas, FX quotes and arrival rules require verification. The existing live paper portfolio keeps its saved zero-Earn settings.": "历史理财回测已支持所选研究模型。真实账户理财尚未启用，真实产品资格、利率、额度、兑换报价及到账规则仍需核验。现有实时模拟账户保持已保存的零理财设置。",
  "Selects zero Earn, hourly TRX interest only, or the simplified hourly TRX and USDGO scenario. All three trading variants support these historical models.": "选择不计理财、仅 TRX 小时理财，或 TRX / USDGO 简化小时理财。三种买卖研究版本都支持这些历史模型。",
  "Select the model in Historical Earn assumptions above. The simplified model converts idle USDT to USDGO at 1:1 with zero exchange costs and instant redemption. It does not reconstruct actual historical products.": "在上方“历史理财研究假设”中选择。简化模型按 1:1、零兑换费用、即时赎回配置闲置 USDGO，未还原实际历史产品。",
  "Fixed annual simple-rate input. Each eligible full hour earns quantity × APR ÷ 365 ÷ 24. Received TRX is retained separately from principal.": "固定年化单利率输入。每个完整计息小时的收益 = 有效数量 × 年化利率 ÷ 365 ÷ 24。到账 TRX 与本金分开留存。",
  "Edit TRX APR above. Subscriptions start next hour and pay after that full hour; reinvested interest has the same delay. Redeemed quantities do not earn for the incomplete hour. TRX interest never funds a losing principal sale.": "在上方修改 TRX 年化利率。申购下一整点起息，经过完整一小时后派息，复投同样等待；当小时赎回数量不计该小时收益。TRX 利息不用于补贴亏损本金卖出。",
  "Fixed annual simple-rate input for the simulated USDGO balance. Hourly credits are valued at the model’s 1:1 rate and increase deployable capital.": "模拟 USDGO 余额的固定年化单利率输入。小时派息按模型的 1:1 汇率估值，并增加可部署资金。",
  "Edit USDGO APR above. The simplified model uses next-hour accrual and later hourly payment, with the same delay on reinvestment. Only eligible USDGO earns this income; USDT is not independently credited at this rate.": "在上方修改 USDGO 年化利率。简化模型下一整点起息，再按小时派息，复投同样等待。仅合格 USDGO 余额获得此收益，不同时给 USDT 余额重复计息。",
  "This result uses the zero-Earn model.": "本次结果使用零理财模型。",
  "Only the simplified TRX and USDGO model credits USDGO interest.": "仅 TRX / USDGO 简化模型计入 USDGO 利息。",
  "Condition: the historical model includes TRX interest.": "条件：历史模型包含 TRX 理财。",
  "Condition: use the simplified hourly TRX and USDGO model.": "条件：使用 TRX / USDGO 简化小时理财模型。",
  "Deployable capital B includes starting capital, net external flows, realized principal profit, credited stablecoin interest and realized FX profit. Unrealized TRX gains and retained TRX interest do not create spendable cash. Occupation is the larger of TRX market-value share and remaining principal cost divided by B, capped at 100%.": "可部署本金 B 包含初始本金、净外部划入、已实现波段利润、已到账稳定币收益和已实现兑换损益。TRX 浮盈与留存 TRX 利息不会凭空增加可买入现金。占用程度取“TRX 市值占总权益比例”和“剩余本金成本 ÷ B”中较大的一项，上限 100%。",
  "Adjust this research input and rerun; recorded historical results do not change. These values are scenario assumptions, not verified account terms.": "调整研究参数后需重新运行，已保存历史结果不变；这些取值是情景假设，不是已核验的账户条件。",
  "Cash allocation and product assumptions": "现金配置与产品假设",
  "Strong-rebound sell coefficient": "卖出反弹强度系数",
  "Adds a bounded fraction when the rebound exceeds the signal threshold; 0.2 allows up to 20 extra percentage points at twice the threshold. Principal profit checks still apply.": "反弹超过触发门槛后增加卖出比例；0.2 表示反弹达到门槛两倍时最多额外加 20 个百分点，仍须逐批盈利。",
  "USDT alternative research APR": "USDT 替代研究年化",
  "The assumed hourly USDT yield when funds stay in USDT; cash allocation compares this alternative with USDGO after costs. Zero is an explicit research assumption.": "闲置 USDT 的假设小时收益率；择优配置将它与扣除成本后的 USDGO 收益比较。0 是明确的研究假设。",
  "Bounded cash forecast horizon": "现金收益预测窗口",
  "A preset forecast in hours, bounded to 30 days. It does not use the actual future interval until the next TRX purchase. Larger horizons can cover more conversion costs.": "预先设定的预测小时数，上限 30 天，不读取未来真实买入间隔。窗口越长，预计收益越可能覆盖兑换成本。",
  "Minimum cash conversion value": "最小现金切换金额",
  "Minimum USDT spend for a cash conversion, including after quota limits. Smaller balances remain in USDT rather than repeatedly exchanging dust.": "现金兑换的最低 USDT 支出，额度限制后的实际金额也须达标；更小余额保留为 USDT，避免零头反复兑换。",
  "Required net switching benefit": "净切换收益余量",
  "USDGO expected proceeds must exceed staying in USDT by this amount after both FX legs, spreads, slippage and accrual gaps. Zero still requires a strictly positive benefit.": "扣除双边兑换费用、价差、滑点、计息空档后，USDGO 预计结果须比继续持有 USDT 多出此金额。0 仍要求净增益严格为正。",
  "Cash reconversion cooldown": "现金反向再配置等待",
  "After redemption for a TRX purchase, delay reinvesting leftover cash into USDGO by these minutes. Valid TRX purchase funding can interrupt the hold.": "为 TRX 买入赎回后，剩余现金需等待这些分钟再转入 USDGO；有效的 TRX 买入资金需求可打断保持条件。",
  "USDGO research reference price": "USDGO 研究参考价",
  "USDT value of one USDGO. Bid and ask are derived from this reference and the spread; existing USDGO is valued at the reference, not automatically at one.": "每 1 USDGO 的 USDT 估值。参考价与价差共同生成买卖报价；已有 USDGO 按此价格估值，不自动永远记作 1。",
  "Full research FX spread": "研究兑换双边价差",
  "The total bid/ask spread as a fraction of the reference; each side uses half. A larger spread raises roundtrip costs and can prevent a cash switch.": "买卖报价总价差占参考价的比例，两侧各用一半。价差增大会增加往返成本，也可能让切换不再合格。",
  "Effective research FX fee": "研究兑换净费率",
  "Effective fee charged on each FX leg. It is already the modeled final cost and receives no additional TRX rebate, preventing a second deduction of the rebate.": "每次兑换实际承担的净费用率，已作为模型最终成本，不再额外套用 TRX 返佣，避免把返佣重复减两次。",
  "Research FX slippage": "研究兑换滑点",
  "Worsens each FX quote by this fraction. It enters both forecast and actual simulated exchange once, separately from the spread and fee.": "按此比例恶化每侧兑换报价。预测与模拟实际兑换各按同一规则计算一次，与价差和手续费分别计入。",
  "Research FX quantity precision": "研究兑换数量精度",
  "USDGO conversion quantities round down to these decimal places. This is simulation precision, not a verified exchange market rule.": "USDGO 兑换数量向下截取到这些小数位；这是模拟精度，不是已核验的交易所精度。",
  "Maximum permitted USDGO deviation": "USDGO 允许价格偏离",
  "Stop new USDGO expansion or purchase-funding conversions when the reference deviates from one by more than this fraction. Holdings stay listed and are valued at the known price.": "参考价偏离 1 超过此比例时，停止新增 USDGO 配置及相关买入资金兑换；已有资产继续列账并按已知价格估值。",
  "Simulated redemption arrival delay": "模拟赎回到账等待",
  "Minutes until assets requested for a trade become available. The plan must still be valid at arrival; expiry releases reservations without an invented fill.": "为交易准备的资产经过这些分钟才可用。到账后仍须满足信号与盈利条件；过期则释放预留，不虚构成交。",
  "USDGO quote availability assumption": "USDGO 报价可用假设",
  "Models a usable FX quote. Missing quotes pause dependent conversions and USDGO income valuation; they are not treated as a free executable exchange.": "模拟是否存在可用兑换报价。缺报价时暂停依赖它的兑换和 USDGO 收益计价，不能把未知当作可免费成交。",
  "Injected FX deviation timing": "场景偏离注入时点",
  "Minutes from this run’s beginning until an external FX shock. The cash forecast sees only the current quote and never anticipates the injection.": "从本次起点经过这些分钟后，注入外部价格偏离情景；现金预测只使用当前报价，不提前利用该注入时点。",
  "Injected FX reference price": "场景偏离注入价格",
  "The reference price after a scenario shock. Zero disables the injection; a positive value changes valuation at the configured time without forcing liquidation.": "情景偏离后的参考价。0 表示关闭注入；正数在设定时点改变估值，不强制亏损清仓。",
  "TRX product availability assumption": "TRX 理财可用假设",
  "If unavailable, TRX remains held without that modeled yield. Product unavailability alone does not reject an otherwise valid principal purchase.": "不可用时，TRX 继续持有但不计此路径收益；不能仅因为理财不可用而拒绝合格的本金买入。",
  "USDGO product availability assumption": "USDGO 理财可用假设",
  "If unavailable, stop new net-benefit allocations to USDGO and do not credit its modeled income. Existing assets are not automatically liquidated.": "不可用时，停止择优模型中的新增 USDGO 配置并不计其模拟收益；已有资产不自动清仓。",
  "Eligible TRX interest quantity cap": "TRX 合格计息数量上限",
  "Maximum TRX quantity receiving the modeled APR. Zero means no research limit; excess quantity stays owned but earns no additional modeled income.": "享受模型年化的 TRX 数量上限。0 表示研究中不设上限；超出部分仍归账户持有，但不额外计算该路径收益。",
  "USDGO subscription and interest cap": "USDGO 申购与计息上限",
  "Maximum USDGO allocation and eligible interest base. Zero means no research limit; unused funds may remain in USDT.": "USDGO 配置与有效计息基数的上限。0 表示研究中不设上限；未使用的资金可以保留在 USDT。",
  "Dynamic thresholds only": "仅动态门槛",
  "Dynamic quantities only": "仅动态数量",
  "Dynamic periods only": "仅动态周期",
  "Dynamic thresholds and periods": "动态门槛与周期",
  "Dynamic quantities and periods": "动态数量与周期",
  "Dynamic": "动态",
  "Fixed": "固定",
  "Running": "运行中",
  "candles": "根 K 线",
  "Hourly Earn with net-benefit cash allocation": "按净增益择优配置的小时理财",
  "Threshold, quantity and period mechanism validation": "门槛、数量、周期机制验证",
  "Saved mechanism validation batches": "已保存的机制验证批次",
  "Run mechanism and stress validation": "运行机制与压力验证",
  "Experiment combination": "实验组合",
  "Threshold mechanism": "门槛机制",
  "Quantity mechanism": "数量机制",
  "Period mechanism": "周期机制",
  "Mean TRX exposure": "平均 TRX 市值仓位",
  "Average marginal mechanism effects": "机制平均边际影响",
  "Mechanism": "机制",
  "Mean net-profit change (USDT)": "平均净收益变化（USDT）",
  "Mean return change (percentage points)": "平均收益率变化（百分点）",
  "Mean drawdown change (percentage points)": "平均最大回撤变化（百分点）",
  "Matched mechanism pairs": "查看逐对机制对照",
  "Baseline combination": "基准组合",
  "Enabled combination": "开启该机制后",
  "Net-profit change (USDT)": "净收益变化（USDT）",
  "Drawdown change (percentage points)": "最大回撤变化（百分点）",
  "Chronological segment diagnosis": "按时间分段的历史诊断",
  "Stress scenarios for the complete dynamic mechanism": "全动态机制的压力情景",
  "Scenario": "情景",
  "Zero Earn scenario": "零理财收益",
  "Half APR scenario": "理财年化减半",
  "Higher spot costs scenario": "现货费率及滑点提高",
  "FX friction scenario": "增加兑换费用、价差及滑点",
  "60-minute redemption scenario": "赎回等待 60 分钟",
  "USDGO 3% deviation scenario": "USDGO 中途偏离 3%",
  "Eight combinations use identical data and non-mechanism parameters. Each pair changes one mechanism switch; interactions with other enabled mechanisms can remain. No coefficient search was performed.": "8 种组合使用完全相同的数据与其余参数。每对比较只改变一个机制开关，其它已开启机制可能产生交互影响；本批次未进行系数搜索。",
  "This is retrospective diagnosis on already observed history, not a genuinely unseen holdout or live approval. Segment runs reset virtual capital and the anchor; their profits must not be added as one continuous portfolio.": "这是对已观察历史的回顾诊断，不能宣称严格未见样本或实盘验收。各分段重置虚拟本金与锚点，不能把分段利润相加当成一个连续账户收益。",
  "Each mechanism has four matched on/off pairs. Positive profit or return changes increase performance in this sample; negative drawdown changes reduce drawdown. The averages are context-dependent, not guaranteed future improvements.": "每个机制均有 4 对开启／关闭对照。收益变化为正表示本样本中收益增加，回撤变化为负表示回撤降低；这些平均值依赖其它机制状态，不保证未来改善。",
  "This interval is too short for two quarterly segments; only full-interval and stress diagnosis are available.": "本区间不足以形成两段季度窗口，仅提供全区间机制与压力诊断。",
  "Extra sell fraction for a strong rebound": "强反弹额外卖出系数",
  "Cash forecast horizon (hours)": "现金预测窗口（小时）",
  "USDT alternative APR (fraction)": "USDT 替代年化（0.01 = 1%）",
  "Minimum cash switch (USDT)": "最小现金切换金额（USDT）",
  "Cash switch profit margin (USDT)": "净切换收益余量（USDT）",
  "FX reference rate (USDT per USDGO)": "USDGO 参考价（USDT / USDGO）",
  "Full FX spread (fraction)": "兑换总价差（小数）",
  "Effective FX fee (fraction)": "兑换净费率（小数）",
  "FX slippage (fraction)": "兑换滑点（小数）",
  "Redemption wait (minutes)": "赎回到账等待（分钟）",
  "Minimum cash hold (minutes)": "现金反向再配置等待（分钟）",
  "TRX eligible quota (0 = unlimited)": "TRX 合格数量上限（0 = 不设上限）",
  "USDGO eligible quota (0 = unlimited)": "USDGO 合格数量上限（0 = 不设上限）",
  "These are scenario inputs, not verified exchange terms. FX fees are effective costs and do not receive an additional TRX fee rebate. The forecast uses a preset bounded horizon, never the future actual time until the next trade.": "这些输入是研究情景，不是已核验的交易所条款。兑换费率为实际承担的净成本，不额外套用 TRX 返佣。预测使用预先设定的有限窗口，不读取未来真实交易间隔。",
  "Apply research settings to paused paper portfolio": "将研究参数应用到暂停的模拟账户",
  "Refresh paused paper market data": "刷新暂停账户的行情",
  "Resume new purchases": "恢复新增买入",
  "Stop new purchases only": "仅停止新增买入",
  "Saved paper strategy and Earn model": "模拟账户已保存的策略与理财口径",
  "Cash allocation state": "现金配置状态",
  "Stopping new purchases leaves profitable sales and simulated Earn available. Pausing suspends ordinary trading without liquidation. Parameter application preserves holdings, capital and the execution anchor; existing Earn terms cannot be changed while Earn assets are held.": "仅停止新增买入后，合格盈利卖出与模拟理财仍可继续。暂停会停止普通交易，不清仓。应用参数保留持仓、本金与锚点；仍持有理财资产时不能改变既有理财条款。",
  "Manual paper exit of principal or retained interest": "模拟本金／留存利息的主动退出",
  "Exit source": "处置来源",
  "Exit quantity (TRX)": "处置数量（TRX）",
  "Accept the virtual exit price and possible loss": "接受模拟处置价格及可能亏损",
  "Record manual virtual exit": "记录主动模拟处置",
  "This is a separately authorized virtual exit, may realize losses, and does not count as an ordinary profitable signal. Pause first and refresh market data. No real exchange order is sent.": "这是独立授权的虚拟处置，可能实现亏损，不计作普通盈利信号。请先暂停并刷新行情；不会发送真实交易所订单。",
  "Historical and live paper research share the same versioned trading and Earn engine. Real-account operations remain disabled. Current product rules, actual historical APR and FX quotes still require separate verification; saved portfolios are not automatically reconfigured.": "历史回测与实时模拟共用版本化的交易、理财引擎。真实账户操作保持关闭；真实产品规则、历史 APR 和兑换报价仍需另行核验，既有模拟账户不会自动改配置。",
  "This combination uses fixed thresholds.": "本组合使用固定门槛。",
  "This combination uses fixed fractions.": "本组合使用固定比例。",
  "Only dynamic sizing or period selection uses this volatility reference.": "仅动态数量或动态周期使用该波动参考值。",
  "This parameter is only used by net-benefit cash allocation.": "该参数仅用于按净增益择优配置的模型。",
  "No FX deviation is injected in this saved scenario.": "本次情景未注入价格偏离。",
  "This combination uses fixed confirmation periods.": "本组合使用固定确认周期。",
  "This model does not include USDGO interest.": "本模型不计 USDGO 利息。",
  "Condition: use net-benefit cash allocation.": "条件：使用按净增益择优配置的模型。",
  "Condition: simulated Earn is enabled.": "条件：已开启模拟理财。",
  "Condition: a positive FX shock rate is configured in the net-benefit scenario.": "条件：择优模型中已设置正数的偏离注入价格。",
  "Condition: the model includes USDGO interest.": "条件：模型包含 USDGO 理财。",
  "Dynamic sizing adds 0.4 × occupation and a bounded boost for rebounds beyond the signal threshold, capped at 100%. Profitable lots can reduce the sale and tail completion can increase it. Change Base sell fraction under Research costs and sizing.": "动态数量在基础比例上增加“0.4 × 占用程度”和超过门槛的反弹反馈，上限 100%。合格盈利量可减少实际卖出，尾仓补齐可增加。基础比例在上方研究设置中修改。",
  "positive_cash_net_benefit": "预计现金净增益为正",
  "cash_cost_exceeds_benefit": "预计收益不足以覆盖切换成本",
  "usdgo_quote_missing": "USDGO 报价缺失，暂停相关动作",
  "usdgo_price_deviation": "USDGO 价格偏离，暂停新增及相关兑换",
  "usdgo_product_unavailable": "USDGO 产品不可用",
  "minimum_switch_value": "余额低于最小切换金额",
  "cash_hold_not_elapsed": "等待现金反向再配置时点",
  "usdgo_quota_exhausted": "USDGO 额度已用完",
  "simplified_cash_policy": "简化现金配置",
  "cash_waiting": "等待现金配置",
  "parameters_updated_waiting_new_signal": "参数已更新，等待新信号",
  "manual_exit_recorded": "主动处置已记录",
  "fx_valuation_pending": "USDGO 估值待核实，暂停依赖它的动态决策",
  "Prepare virtual redemption for this exit": "准备本次模拟赎回",
  "Cancel prepared manual exit": "取消已准备的手动退出",
  "Prepared exit": "已准备退出数量",
  "Funds available after (UTC)": "赎回预计到账时间（UTC）",
  "After arrival, refresh the market price and explicitly accept any loss before recording the exit.": "到账后刷新行情，并接受模拟成交价格及可能亏损，再记录退出。",
  "Interest disposal accounted separately": "利息处置单独计账",
  "Selects zero Earn, hourly TRX interest only, simplified hourly TRX and USDGO, or the cash net-benefit hourly model. All eight trading combinations support these research models.": "选择不计理财、仅计 TRX 小时利息、TRX 与 USDGO 简化小时模型，或现金净收益小时模型。八种交易组合均支持这些研究模型。",
  "Fixed annual simple-rate input for eligible simulated USDGO. Hourly credits use the recorded research exchange rate and increase deployable capital; the simplified model fixes that rate at 1:1.": "模拟 USDGO 的固定年化单利输入，仅合格份额计息。小时派息按记录的研究兑换价格估值并增加可投资资金；简化模型固定按 1:1 估值。",
  "Cash net-benefit hourly model": "现金净收益小时模型",
  "Buy / sell orders": "买入／卖出订单数",
  "If redemption takes longer than a signal remains valid, the order expires. A scenario with no TRX trades and zero drawdown is a cash-only outcome, not evidence of superior trading.": "赎回等待超过信号有效期时，订单会失效。若没有任何 TRX 成交且回撤为零，只说明这一情景一直持有现金，不能据此认定交易策略更优。",
  "The applicability column compares the three primary variants. The eight mechanism experiments may use other combinations; their actual enabled parameters are shown by this saved result’s status. Conditional parameters require the condition below their variant labels.": "“适用研究版本”列对照三个主要版本。八种机制实验可能采用其它组合，其实际启用参数以“本次状态”为准；条件使用的参数需满足版本说明下方的条件。",
  "Beijing time (UTC+8)": "北京时间（UTC+8）",
  "Display and input timezone": "显示与输入时区",
  "Dates and time inputs use this timezone. Requests and stored timestamps remain UTC; changing timezone preserves existing intervals.": "日期显示与时间输入统一使用此时区。请求与存储仍使用 UTC；切换时区保留已经选定的实际区间。",
  "Start date ({zone})": "开始日期（{zone}）",
  "End date ({zone})": "结束日期（{zone}）",
  "End date ({zone}, exclusive)": "结束日期（{zone}，不包含结束时刻）",
  "Start time ({zone})": "开始时间（{zone}）",
  "End time ({zone})": "结束时间（{zone}）",
  "Time inputs use {zone}": "时间输入使用 {zone}",
  "Time range ({zone})": "时间范围（{zone}）",
  "UTC query interval": "对应 UTC 区间",
  "End boundary is exclusive. To include a full day, choose 00:00 of the next day. UTC candle boundaries remain unchanged.": "结束时刻不包含在区间内。若要包含完整一天，请选择次日 00:00；K 线仍保持交易所原有 UTC 划分。",
  "Time ({zone})": "时间（{zone}）",
  "Latest closed candle ({zone})": "最近已闭合 K 线（{zone}）",
  "Funds available after ({zone})": "赎回预计到账时间（{zone}）",
  "Calendar grouping ({zone})": "统计按 {zone} 的自然日／周／月分组",
  "Saved backtest calendar statistics retain their original UTC grouping; changing display timezone does not recompute these historical metrics.": "已保存回测的日／周／月统计保留原有 UTC 分组；切换显示时区不会重新计算这些历史指标。",
  "Buy count": "买入次数",
  "Sell count": "卖出次数",
  "Buy {buy} times; sell {sell} times": "买入 {buy} 次；卖出 {sell} 次",
  "Backtest diagnosis": "回测诊断",
  "Export this research package": "导出本批研究包",
  "Observed historical research": "已观察历史研究",
  "Loading diagnosis": "正在读取诊断",
  "Diagnosis loading timed out. Your saved result is unchanged; retry loading.": "读取诊断超时，已保存的回测结果未改变，请点击重试。",
  "Retry loading diagnosis": "重新读取诊断",
  "Not collected; rerun required": "未采集，需要重跑",
  "Rerun diagnosis with the saved parameters and data": "按当次参数与同一数据重跑诊断",
  "No TRX wave execution; cash income only": "未执行波段，仅现金收益",
  "Trading activity": "交易活跃度",
  "Signal outcomes": "信号去向",
  "Actual thresholds and periods": "实际门槛与周期",
  "Order sizing and lots": "交易金额与本金批次",
  "Drawdown review": "回撤复盘",
  "Income reconciliation": "收益分解与核对",
  "Earn and conversion traces": "理财、兑换与赎回",
  "Month": "月份",
  "Independent buy signals": "独立买入信号",
  "Independent sell signals": "独立卖出信号",
  "Submitted buy orders": "提交买单",
  "Submitted sell orders": "提交卖单",
  "Buy fills": "买入成交片段",
  "Sell fills": "卖出成交片段",
  "Active trading days": "活跃交易天数",
  "View month": "查看当月",
  "Longest interval without principal execution": "最长本金无成交区间",
  "Median / longest execution interval (minutes)": "成交间隔中位数／最长间隔（分钟）",
  "Close evaluations": "收盘评估",
  "Independent signals": "独立信号",
  "Eligible": "通过资格检查",
  "Awaiting funds": "等待资金",
  "Submitted orders": "提交订单",
  "Executed decisions": "已成交决策",
  "Fill fragments": "成交片段",
  "No signal": "没有形成信号",
  "Signals without execution": "有信号但未成交",
  "Primary reason": "主要终止原因",
  "Actual threshold": "实际门槛",
  "Price change from anchor": "相对锚点的价格变化",
  "Anchor after execution": "完成成交后的锚点",
  "Capital occupation": "资金占用反馈",
  "TRX exposure": "TRX 实际敞口",
  "Deployable capital": "可部署本金",
  "USDGO awaiting redemption": "赎回中的 USDGO",
  "Retained interest TRX": "留存利息 TRX",
  "Profitable quantity": "合格盈利数量",
  "Profitable lots": "合格盈利批次数",
  "Planned notional": "计划成交金额",
  "Constrained notional": "约束后的金额",
  "Executed notional": "实际成交金额",
  "Planned quantity": "计划数量",
  "Target quantity": "约束后的数量",
  "Executed quantity": "实际成交数量",
  "Sizing factor": "数量调整因子",
  "Funds ready at": "资金可执行时间",
  "Signal expires at": "信号到期时间",
  "Virtual submission time": "模拟订单提交时间",
  "Opportunity ended at": "机会终止时间",
  "Final status": "最终状态",
  "Additional restrictions": "附加限制",
  "Repeated signal checks": "同一信号重复检查次数",
  "Base threshold": "基础门槛",
  "Volatility adjustment": "波动调整",
  "Occupation adjustment": "仓位调整",
  "Threshold before clipping": "截断前门槛",
  "Clipped at lower limit": "触及门槛下限",
  "Clipped at upper limit": "触及门槛上限",
  "Previous confirmation period": "上次确认周期",
  "Previous anchor": "成交前锚点",
  "Current anchor": "成交后锚点",
  "Anchor source": "锚点来源",
  "Related decision ID": "关联交易决策 ID",
  "Original quantity": "原始数量",
  "Remaining quantity": "剩余数量",
  "Sold quantity": "已卖数量",
  "Unit cost": "单位成本",
  "Unrealized principal P&L": "本金未实现盈亏",
  "Realized principal profit": "本金已实现净利润",
  "Holding time (minutes)": "持有时间（分钟）",
  "Ordinary sale eligible": "满足普通卖出资格",
  "Operation": "资金操作",
  "Asset": "币种",
  "Accrual starts at": "起息时间",
  "Expected arrival": "预计到账时间",
  "Credited at": "实际入账时间",
  "Received amount": "实际收到金额",
  "Paid amount": "实际支付金额",
  "Execution rate": "实际兑换价格",
  "Cost at execution rate": "兑换综合成本（相对当时估值）",
  "Entry conversion cost": "申购兑换综合成本",
  "Observed exit cost": "已发生换回成本",
  "Observed total conversion cost": "已发生兑换总成本",
  "Attributed interest quantity": "归属的实际利息数量",
  "Attributed interest value": "归属的实际利息价值",
  "Last redemption time": "最后赎回时间",
  "Complete roundtrip cost recovered": "完成周期的往返成本已覆盖",
  "Interest covers observed costs": "利息覆盖已发生成本",
  "Forecast at conversion": "兑换时的收益预测",
  "Attribution convention": "收益归属口径",
  "Redeemed quantity": "已赎回数量",
  "Signal formed": "信号已形成",
  "Funds ready": "资金就绪",
  "Submitted": "已提交",
  "Executed": "已成交",
  "Not executed": "未成交",
  "Ineligible": "未通过资格检查",
  "Partially executed and closed": "部分成交后终止",
  "Still held": "仍未退出",
  "Exited": "已退出",
  "Incomplete cycle": "未完成周期",
  "Completed cycle": "已完成周期",
  "No net-profitable lot": "没有净盈利批次",
  "Below minimum quantity": "低于最小交易数量",
  "Below minimum notional": "低于最小订单金额",
  "No deployable cash": "没有可部署现金",
  "Assets present but unavailable for funding": "有理财资产但不具备资金执行条件",
  "Signal expired": "信号过期",
  "Execution price deviated too far": "执行价格偏离过大",
  "Price condition no longer met": "执行时价格条件失效",
  "No net profit after execution costs": "重新计入费用后不再盈利",
  "No next candle to execute": "数据结束，缺少下一根执行 K 线",
  "Not a selected confirmation close": "不是所选周期的收盘时点",
  "Insufficient change from anchor": "相对锚点的变化不足",
  "Warming up": "预热中",
  "Principal empty, waiting": "本金空仓等待",
  "Only interest TRX remains": "仅剩利息 TRX",
  "Principal held normally": "正常持有本金",
  "Capital nearly fully occupied": "资金接近用满",
  "Subscription": "理财申购",
  "Complete accrual hour": "完整计息小时",
  "Interest credited": "派息入账",
  "Redemption requested": "赎回申请",
  "Redemption arrived": "赎回到账",
  "Redemption cancelled": "赎回取消并恢复申购",
  "Redeemed asset executed": "赎回资产完成成交",
  "Realized principal wave profit": "本金已实现波段净利润",
  "TRX interest value when credited": "TRX 利息入账时价值",
  "TRX interest subsequent price P&L": "TRX 利息后续价格盈亏",
  "Stablecoin interest": "稳定币理财利息",
  "Realized conversion P&L": "稳定币兑换已实现损益",
  "Unrealized conversion P&L": "稳定币兑换未实现损益",
  "Initial confirmed close": "首次确认收盘价",
  "Principal execution VWAP": "本金实际成交均价",
  "Fixed confirmation period": "固定确认周期",
  "Occupation or volatility tier": "仓位或波动档位变化",
  "Perspective": "统计视角",
  "P90": "90% 分位数",
  "Maximum": "最大值",
  "At lower limit": "处于下限的时间比例",
  "At upper limit": "处于上限的时间比例",
  "By runtime": "按运行时间",
  "By close evaluation": "按收盘评估次数",
  "Period switches": "周期切换",
  "Anchor changes": "锚点变化",
  "Planned → constrained → executed notional": "计划金额 → 约束后金额 → 实际成交金额",
  "Median executed notional": "每笔成交金额中位数",
  "Median share of deployable capital": "每笔占可部署本金比例中位数",
  "Losing principal cost locked": "亏损本金占用金额",
  "Principal cost held over 30 days": "持有超过 30 天的本金成本",
  "Median / longest duration of exited lots (minutes)": "已退出批次持有时间中位数／最长（分钟）",
  "Median / longest duration of remaining lots (minutes)": "未退出批次持有时间中位数／最长（分钟）",
  "Longest no-trade interval": "最长无交易区间",
  "Review longest no-trade interval": "复盘最长无交易区间",
  "Equity peak": "权益高点",
  "Equity trough": "权益低点",
  "Recovery": "恢复时间",
  "Decline minutes": "下跌时长（分钟）",
  "Recovery minutes": "恢复时长（分钟）",
  "Not recovered": "尚未恢复",
  "Review": "复盘",
  "Equity change after net deposits": "剔除净入金后的权益变化",
  "Reconciliation residual": "总账核对差额",
  "Earn operations": "理财申赎与派息流水",
  "Conversion executions": "逐次兑换记录",
  "Conversion holding cycles": "兑换持有周期",
  "Saved record detail": "本次保存的记录详情",
  "Synchronized interval review": "区间同步复盘",
  "Interval executions": "区间成交记录",
  "Interval signals": "区间信号记录",
  "Balances at first / last sampled close": "区间首尾收盘资金状态",
  "Recorded balance changes in this interval": "区间账本累计值变化",
  "No-trade intervals in this month": "当月无成交区间",
  "Principal TRX value": "本金 TRX 市值",
  "Interest TRX value": "利息 TRX 市值",
  "Stablecoin value": "稳定币资产市值",
  "No records in this interval": "此区间没有记录",
  "Controlled parameter comparisons and benchmarks": "受控参数对比与公平基准",
  "Saved baseline": "已保存基准结果",
  "One parameter group": "一次调整一组参数",
  "Candidate values, comma separated": "候选值，用逗号分隔",
  "Run controlled comparison": "运行受控对比",
  "Baseline value": "基准参数值",
  "Inherit research variant": "沿用研究版本设置",
  "Saved controlled comparison batches": "已保存的受控对比批次",
  "Candidate": "候选方案",
  "Return change": "收益率变化",
  "Drawdown change": "最大回撤变化",
  "Executed buy / sell notional": "累计买入／卖出金额",
  "Earn contribution": "理财收益贡献",
  "Baseline": "基准",
  "Research drawdown filter (%)": "研究回撤筛选（%）",
  "Highest return within filter": "筛选内收益率最高方案",
  "No eligible wave strategy": "没有符合条件的波段方案",
  "Compatible passive benchmarks": "相同假设下的被动基准",
  "Hold USDT with compatible interest": "仅持有 USDT 并按配置生息",
  "Hold USDGO with compatible interest": "仅持有 USDGO 并按配置生息",
  "Hold TRX with compatible Earn": "持有 TRX 并参加同样理财",
  "Simple 25% initial TRX allocation": "初始 25% 本金买入 TRX 后持有",
  "Cash-only benchmark": "仅现金资产基准",
  "Dynamic buy sizing": "动态买入数量",
  "Dynamic sell sizing": "动态卖出数量",
  "Zero Earn independent rerun": "关闭理财独立重跑",
  "Use true or false for sizing switches": "数量开关请输入 true 或 false",
  "Enter one to five valid candidate values": "请输入 1～5 个有效候选值",
  "Record ID": "流水 ID",
  "Diagnostics observe one continuous replay and never change trading rules. Old records are not backfilled.": "诊断来自一次连续回放，只记录事实，不改变买卖规则。旧结果不会补造记录。",
  "A new result is saved only if the original trades, equity and drawdown can be reproduced.": "仅在原成交、权益与回撤能够逐项复现时保存新诊断结果。",
  "Monthly counts slice a continuous replay; capital and anchor are never reset.": "按月切分同一次连续回测，本金与锚点不会重新初始化。",
  "Repeated checks of a persistent signal share one opportunity ID. Each opportunity has one final primary reason; additional restrictions are tags.": "持续存在的同一信号共用一个机会 ID；每个机会只保留一个最终主要原因，其他限制作为附加标签。",
  "Submission is virtual. This OHLCV model does not simulate exchange rejection or orderbook partial fills.": "提交订单属于历史模拟。当前 K 线模型不模拟交易所拒单和盘口部分成交。",
  "Time-weighted conditions and decision-weighted conditions are separate distributions. Details show base, volatility, occupation and clipping.": "按时间与按收盘评估次数分别统计；明细展示基础门槛、波动调整、仓位调整和最终截断。",
  "USDGO Earn and redemption balances are assets, not instantly deployable cash. Retained TRX interest contributes to NAV and exposure but is excluded from ordinary principal sales.": "理财及赎回中的 USDGO 是资产，不能当作即时现金；留存 TRX 利息计入权益和敞口，普通本金卖出不会出售它。",
  "Largest drawdowns use every minute of equity. Click to inspect prices, exposure, trades and unexecuted signals; the system does not infer a cause.": "回撤按逐分钟权益计算。点击查看价格、敞口、成交及未成交信号；系统展示事实，不预先推断原因。",
  "Components already include booked fees and credited rebates. Do not deduct or add them again. A zero-Earn rerun follows a different reinvestment and trading path.": "收益分项已经计入费用及到账返佣，不可再次扣减或加回。关闭理财重跑会改变复投和后续交易路径。",
  "Subscriptions, full accrual hours, credited interest, redemption requests, arrivals and cancellations are linked to decision IDs.": "理财申购、完整计息小时、派息到账、赎回申请、到账与取消均可关联交易决策。",
  "USDGO interest is attributed pro rata across eligible conversion cohorts. Waiting withdrawals use LIFO, then eligible withdrawals use pro rata. Incomplete cycles omit future exit costs.": "USDGO 利息按合格计息数量比例归属兑换批次；赎回先扣待起息批次（后进先出），再按比例扣已起息批次。未完成周期不预估未来换回成本。",
  "The chart is sampled for display; drawdowns and exports use full minute records.": "图表为展示采样；回撤计算及研究包保留完整逐分钟记录。",
  "Select the currently displayed saved result as baseline. Each batch changes one group only, saves all effective parameters, and preserves previous studies.": "以当前展示的已保存结果为基准，一批只调整一组参数。保存完整实际参数，旧实验结果不覆盖。",
  "Observed historical research; previously inspected data is not an unseen validation set. Forward paper simulation remains a separate mode.": "当前属于已观察历史研究；已查看并据此调参的数据不能标成未见验证集。前向纸面模拟为独立模式。",
  "Ratios use decimals: 0.012 = 1.2%. Sizing switches use true / false.": "比例用小数：0.012 表示 1.2%；数量开关用 true／false。",
  "This filters historical outcomes and adds no stop-loss. Cash-only results remain visible but are excluded from wave-strategy ranking.": "此阈值仅筛选历史结果，不增加策略止损。仅现金收益结果保留展示，但不参与波段策略排名。",
  "Same data, initial capital, warmup, costs, product eligibility and hourly accrual. TRX benchmarks buy once and keep inventory; USDGO passive allocation respects costs and quotas. USDT uses its configured APR.": "使用相同数据、本金、预热、费用、产品资格与小时计息。TRX 基准一次买入后持有；USDGO 遵守兑换成本和额度；USDT 使用当次配置年化。",
  "eligible pro-rata income; waiting LIFO, eligible pro-rata redemptions; open cycles omit future exit cost": "按合格数量比例归属利息；赎回先后进先出扣待起息数量，再按比例扣已起息数量；未完成周期不包含未来换回成本。",
  "Dynamic buy sizing override": "动态买入数量独立开关",
  "Dynamic sell sizing override": "动态卖出数量独立开关",
  "Null inherits the variant; true enables only dynamic buy sizing; false disables it.": "空值沿用研究版本；true 仅启用动态买入数量，false 关闭动态买入数量。",
  "Null inherits the variant; true enables only dynamic sell sizing; false disables it.": "空值沿用研究版本；true 仅启用动态卖出数量，false 关闭动态卖出数量。",
  "Change this independently in a controlled comparison; sell sizing remains as saved.": "在受控对比中单独调整，卖出数量规则沿用保存的配置。",
  "Change this independently in a controlled comparison; buy sizing remains as saved.": "在受控对比中单独调整，买入数量规则沿用保存的配置。",
  "Minutes": "分钟",
  "start": "开始时间",
  "end": "结束时间",
  "minutes": "分钟",
  "evaluations": "收盘评估次数",
  "signals": "独立信号数",
  "cash": "USDT 现金",
  "free_cash": "可立即使用的 USDT",
  "usdgo_value": "USDGO 市值",
  "redemption_usdgo_value": "赎回中的 USDGO 市值",
  "gross_fees": "交易所实扣手续费",
  "credited_rebates": "到账返佣",
  "trx_credit_value": "累计 TRX 利息到账价值",
  "trx_interest_value": "留存 TRX 利息市值",
  "lot_changes": "批次浮盈亏变化",
  "peak_at": "权益高点时间",
  "trough_at": "权益低点时间",
  "peak_equity": "高点权益",
  "trough_equity": "低点权益",
  "recovered_at": "恢复时间",
  "end_at": "复盘结束时间",
  "drawdown": "回撤",
  "met": "满足价格条件",
  "first_fill_at": "首次成交时间",
  "last_fill_at": "最后成交时间",
  "execution_check": "执行前检查",
  "cost_basis_note": "费用口径说明",
  "Saved diagnostic research results": "已采集诊断的研究结果",
  "Current result, diagnosis not collected": "当前结果（尚未采集诊断）",
  "Buy base threshold": "买入基础门槛",
  "Sell base threshold": "卖出基础门槛",
  "Buy allocation fraction": "买入基础比例",
  "Sell allocation fraction": "卖出基础比例",
  "profitable_quantity_limited": "合格盈利数量限制了卖出量",
  "available_budget_limited": "可用预算限制了买入量",
  "submitted_quantity": "实际提交数量",
  "snapshot_timing": "仓位快照时点",
  "before principal execution": "本金成交前",
  "peak_funds": "权益高点时的资金状态",
  "trough_funds": "权益低点时的资金状态",
  "opportunity_id": "关联独立机会 ID",
  "last_attempt": "同一机会最后一次信号检查",
  "last_signal_at": "最近信号检查时间",
  "signal_episode_started_at": "独立机会开始时间",
  "peak_quantity": "高点持有数量",
  "peak_cost": "高点持仓成本",
  "trough_quantity": "低点持有数量",
  "trough_cost": "低点持仓成本",
  "unrealized_change": "浮盈亏变化",
  "reference_mark": "当时兑换估值",
  "Lot P&L changes include interval trades and credited rebates, not price changes alone.": "批次浮盈亏变化包含区间买卖和到账返佣影响，不等同于单纯的价格贡献。",
  "expected_usdgo_interest": "预计新增 USDGO 利息",
  "usdt_alternative_interest": "同期 USDT 机会成本",
  "roundtrip_cost": "预计往返成本",
  "expected_net_benefit": "预计净增益",
  "forecast_hours": "预测持有时长（小时）",
  "amount": "预测资金金额",
  "mark": "当时 USDGO 估值",
  "eligible": "符合兑换条件",
  "spend": "预计支付金额",
  "days": "天",
  "records": "条记录",
  "planned_budget": "计划买入预算（含手续费）",
  "original_cost": "本金批次原始买入成本（含到账返佣调整）",
  "original_unit_cost": "原始单位成本（含到账返佣调整）",
  "purchase_cost_basis": "买入成本核算口径",
  "recorded sold allocation costs plus remaining cost, net of credited purchase rebates": "已卖出分配成本加剩余成本；已扣到账的买入返佣。",
  "Warmup and waiting checks": "预热与等待状态检查（分钟次数）",
  "pending_plan_check": "已有信号等待执行",
  "Collected {count} minute closes; buy and sell evaluations occur only at their selected confirmation closes.": "已记录 {count} 次 1m 收盘；正式买卖评估只在各自选定的确认周期收盘进行。",
  "fx_profit": "稳定币兑换已实现损益",
  "Drawdown": "回撤幅度",
  "Lot ID": "本金批次 ID",
  "equity": "总权益",
  "external_flows": "累计净入金",
  "buy_threshold": "实际买入门槛",
  "sell_threshold": "实际卖出门槛",
  "buy_period": "买入确认周期（分钟）",
  "sell_period": "卖出确认周期（分钟）",
  "state": "资金状态",
  "fx_valuation_known": "兑换估值是否可用",
  "usdt_earn_eligible": "已起息 USDT 数量",
  "usdgo_earn_eligible": "已起息 USDGO 数量",
  "redemption_principal_trx": "赎回中的本金 TRX",
  "buy_lower_clipped": "买入门槛触及下限",
  "buy_upper_clipped": "买入门槛触及上限",
  "sell_lower_clipped": "卖出门槛触及下限",
  "sell_upper_clipped": "卖出门槛触及上限",
  "decline_minutes": "下跌时长（分钟）",
  "recovery_minutes": "恢复时长（分钟）",
  "tier": "当前周期档位",
  "relax_count": "连续满足缩短周期条件次数",
  "due_at": "预计到账时间",
  "signal_outcome": "关联机会的最终状态",
  "Execution preflight": "执行前价格与资金预估",
  "Restricted buy-reference recovery": "受限买入参考恢复",
  "Sell sizing inventory basis": "卖出数量计算基数",
  "Maximum profitable inventory sale fraction": "单次出售比例上限",
  "All principal inventory": "全部本金库存",
  "Eligible profitable inventory": "合格盈利库存",
  "Common terms, 12% buy allocation": "共同条件基准：买入比例 12%",
  "P0: preflight, 12% buy allocation": "P0：执行前预估，买入比例 12%",
  "P1: 8% buy allocation": "P1：买入比例 8%",
  "P1: 6% buy allocation": "P1：买入比例 6%",
  "P2: 8% with restricted recovery": "P2：8%＋受限参考恢复",
  "P3: 8% with profitable inventory sizing": "P3：8%＋合格库存出售",
  "Combined recovery and inventory experiment": "恢复与出售节奏组合验证",
  "Pressure baseline, 8% allocation": "压力环境：8% 基准",
  "Pressure combined experiment": "压力环境：组合验证",
  "Focused allocation, recovery and inventory study": "本轮聚焦实验：买入规模、参考恢复与出售节奏",
  "Seven fixed cases: common baseline, preflight, 8%, 6%, restricted recovery, profitable inventory sales and combined verification. A paired conservative pressure case is saved separately.": "固定七组：共同基准、执行前预估、8%、6%、受限参考恢复、合格库存出售、组合验证；另保存一组基准与组合的保守压力对照。",
  "Uses the 2026-10-13 ordinary APR snapshot with tiered interest. Research assumptions: 5,000 TRX / 1,000 USDGO eligible caps; 1-minute redemptions for TRX, USDGO and USDT; FX fee 0.05%, full spread 0.05%, slippage 0.02%. These are not verified account terms.": "采用 2026-10-13 普通活期 APR 快照并按额度分档计息。研究假设：合格额度 5,000 TRX／1,000 USDGO；TRX、USDGO、USDT 赎回等待 1 分钟；兑换手续费 0.05%、完整价差 0.05%、滑点 0.02%。这些是研究参数，不是已核实的账户条款。",
  "Recovery starts after 30 inactive days, freezes a buy reference for 7 days, caps one recovery purchase at 2%, and cools down for 7 days. Old lot costs remain unchanged. The selected result supplies the exact data interval and other strategy settings.": "连续 30 天没有本金成交后，满足条件才启用参考恢复；参考冻结 7 天、恢复买入最多使用可部署本金的 2%、冷却 7 天。老批次保留真实成本。数据区间及其他策略参数取自当前选中的已保存结果。",
  "Run focused research protocol": "运行本轮聚焦实验",
  "Research environment": "研究环境",
  "Ordinary APR snapshot scenario": "普通活期 APR 快照情景",
  "Half APR, restricted quotas, 60-minute redemption pressure": "利率减半、额度收紧、赎回等待 60 分钟压力情景",
  "Changes are measured against each row’s named control. Pressure results are compared only within their own environment. Historical research does not select or activate a live strategy.": "变化值相对于各行标明的对照组计算；压力结果只在同一环境内比较。本批属于历史研究，不自动选定或启用实盘策略。",
  "Comparison control": "对照组",
  "Benchmark curves display hourly samples. Downloads contain every minute of NAV and funds. The 25% benchmark buys once and lets exposure drift; it is not constant-weight rebalancing.": "基准图按小时抽样展示；下载文件包含每分钟净值和资金状态。25% 基准只在初始买入一次，后续仓位随价格变化，不进行恒定比例再平衡。",
  "Full minute NAV": "完整分钟净值",
  "Download minute NAV CSV": "下载逐分钟净值 CSV",
  "Focused research rules": "本轮研究规则与利率快照",
  "Apply these inputs to a separately saved research result; account operations remain disabled.": "用于独立保存的研究结果，真实账户操作继续保持未启用。",
  "Recovery inactivity days": "参考恢复的无成交天数",
  "Recovery reference validity days": "恢复参考有效天数",
  "Recovery cooldown days": "参考恢复冷却天数",
  "Recovery purchase maximum fraction": "恢复买入预算上限",
  "TRX research APR tiers": "TRX 年化利率分档",
  "USDGO research APR tiers": "USDGO 年化利率分档",
  "USDT research APR tiers": "USDT 年化利率分档",
  "APR snapshot source": "利率快照来源",
  "APR observation time in UTC": "利率采集时间（UTC）",
  "APR pressure multiplier": "利率压力倍数",
  "USDT research redemption delay": "USDT 研究赎回等待",
  "Uses the flat research APR": "使用单一研究 APR",
  "Before funding, estimate executable prices using the closed price and configured slippage; reject unprofitable inventory and redemption deadlines that cannot be met. Final execution checks still apply.": "资金准备前，使用已闭合价格及配置的滑点预估执行条件；过滤不盈利库存和无法在信号有效期内到账的赎回。实际成交前继续严格复核。",
  "After prolonged principal inactivity, allow one bounded purchase against a frozen auxiliary reference. Actual fill anchors and old lot costs are retained.": "长期没有本金成交后，允许基于冻结的辅助买入参考进行一次受限买入；实际成交锚点和老批次成本继续保留。",
  "Minimum continuous days without a principal fill before considering recovery.": "启用参考恢复前，必须连续没有本金成交的最短天数。",
  "Freeze the activation close as the buy reference for this many days; no reference chasing within the window.": "使用启动时已闭合的价格作为买入参考，在有效期内冻结，不追随价格抬高。",
  "After expiration or a principal fill, wait this many days before another recovery activation.": "参考失效或完成本金成交后，在此冷却期结束前不再次启用恢复。",
  "The recovery budget is the smaller of the normal buy budget and this share of deployable capital; available funds and market minimums still apply.": "恢复预算取正常买入预算与可部署本金乘此比例的较小值；还要满足可用资金、精度和最小订单条件。",
  "Principal uses all principal TRX for the sale target. Profitable uses only available lots eligible after fees and the execution margin.": "全部本金模式以全部本金 TRX 计算卖出目标；合格库存模式只使用扣费并满足执行余量后盈利、且可执行的本金批次。",
  "Caps the final sell share after occupation and rebound feedback. This is an independent experiment; it does not create a permanent inventory floor.": "对仓位和反弹反馈后的最终出售比例设置上限，作为独立实验参数。",
  "Each cumulative coin quantity cap has an annual rate. Quantities above recorded rate coverage receive no unverified interest.": "每个累计币种数量上限对应一个年化利率，分档计算；超过已记录利率覆盖范围的数量不计未经核实的利息。",
  "Public quote source and frozen snapshot hash, not verified account entitlement or historical rates.": "记录公开报价来源及冻结快照的校验值，不代表已核实账户资格或历史利率。",
  "Time this public rate snapshot was saved. Historical replay uses a fixed scenario, not a reconstructed rate series.": "本次公开利率快照的保存时间；历史回放采用固定情景，并非还原过去每小时的真实利率。",
  "Multiply every flat or tiered rate by this factor for a separately saved pressure scenario.": "将单一或分档利率全部乘以此倍数，用于独立保存的压力情景。",
  "USDT participating in Earn is reserved during redemption, cannot fund a purchase before arrival, and stops accruing while reserved.": "参加理财的 USDT 在赎回期间被保留，到账前不能用于买入，等待期间停止计息。",
  "Decision reference price": "本次决策参考价",
  "Decision reference type": "决策参考类型",
  "Actual shared fill anchor": "实际共用成交锚点",
  "Frozen recovery buy reference": "冻结的恢复买入参考",
  "USDT awaiting redemption": "赎回中的 USDT",
  "Estimated price with slippage": "含滑点的预估执行价",
  "Preflight price condition failed": "预估执行价未满足价格门槛",
  "Redemption cannot arrive before signal expiry": "赎回无法在信号过期前到账",
  "Restricted recovery activated": "已启动受限参考恢复",
  "Recovery reference expired": "恢复参考已过期",
  "Recovery ended after principal execution": "本金成交后结束参考恢复",
  "Inventory used for sizing": "本次数量计算使用的库存",
  "Benchmark": "基准",
  "Average TRX exposure": "平均 TRX 市值仓位",
  "Current research result": "当前查看的研究结果",
  "Restricted buy-reference recovery is disabled in this saved result.": "本次保存结果未启用受限买入参考恢复。",
  "Condition: restricted buy-reference recovery is enabled.": "条件：已启用受限买入参考恢复。",
  "Frozen ordinary APR: TRX 10.14%; USDGO 6.6% within this quota; USDT 7.37% for the first 300 and 2.71% thereafter (4.108% initially for 1,000 USDT). This is a current quote scenario, not historical actual rates. The backtest form keeps its manually entered assumptions.": "冻结的普通活期 APR：TRX 10.14%；本批额度内 USDGO 6.6%；USDT 前 300 枚 7.37%、其余 2.71%（1,000 USDT 初始综合年化 4.108%）。这是当前报价情景，不是历史真实利率。上方普通回测表单继续使用手动输入的研究假设。",
  "Research comparisons": "实验对比",
  "Result details": "结果明细",
  "Backtest settings": "回测设置",
  "Paper portfolio": "模拟账户",
  "Compare experiments, inspect results and understand each decision.": "比较研究方案，查看收益与回撤，理解每一次交易决策。",
  "Research running": "研究任务运行中",
  "Research progress": "研究任务进度",
  "TRX research navigation": "TRX 研究工作区",
  "Selected saved result": "当前选中结果",
  "View this result": "查看该结果",
  "No result selected": "尚未选择回测结果",
  "Comparison types": "实验类型",
  "Focused and controlled studies": "聚焦与受控对比",
  "Three-variant comparison": "三版本对比",
  "Mechanism and stress studies": "机制与压力验证",
  "No saved comparison batch": "暂无三版本对比批次，可在回测设置中创建。",
  "No saved mechanism study": "暂无机制验证批次，可在回测设置中运行。",
  "Equity and market chart": "权益与行情走势",
  "USDGO holdings (USDGO)": "USDGO 持有数量（USDGO）",
  "TRX holdings (TRX)": "TRX 持有数量（TRX）",
  "USDGO holdings include subscribed and redeeming balances. TRX holdings include principal and retained TRX interest. Quantities use independent axes; click legend entries to show or hide a series. Chart points are display samples from this saved continuous account.": "USDGO 数量包含已申购及赎回中的余额；TRX 数量为本金持仓＋留存 TRX 利息。数量使用独立纵轴，点击图例可显示或隐藏曲线。图表使用本次连续账户保存的展示采样点。",
  "This historical result lacks some holding snapshots. Missing points are left blank, not treated as zero.": "该历史结果缺少部分持仓快照，缺失点留空，不按零持仓处理。",
  "Capital, fees and Earn details": "资金、费用与理财明细",
  "Result records": "结果记录",
  "Executed orders": "订单成交",
  "Principal lots": "本金批次",
  "Interest credits": "理财派息",
  "View this diagnosis": "查看该次诊断",
  "This saved result has zero Earn income.": "这次保存结果未计算理财收益。",
  "Select a comparison row to inspect its saved result.": "请先在实验对比中点击“查看明细”，选择要查看的保存结果。",
  "Manual backtest assumptions": "手动回测的研究假设",
  "These settings create a new backtest. Focused studies use their frozen APR snapshot and the selected saved source instead.": "这里的设置用于新建手动回测；聚焦实验使用单独冻结的 APR 快照，并取当前选中结果的数据区间和其余参数。",
  "Accounting and research assumptions": "记账与研究口径",
  "Open a saved batch below. View details to inspect that row; new experiments use the currently selected saved result.": "下方选择已保存批次，点击“查看明细”查看对应结果；新实验以当前选中结果为基准。",
  "Rules for a new focused study": "新建聚焦实验的规则与资金假设",
  "Single-parameter controlled experiment": "单项参数受控对比",
  "Return change (percentage points)": "收益变化（百分点）",
  "Diagnostic records": "诊断记录",
  "Change unit: percentage points": "（百分点）",
  "Legacy rules under the same environment": "旧规则在新环境下的同条件对照",
  "Legacy rules: {name}": "旧规则：{name}",
  "Pressure environment: {name}": "压力环境：{name}",
  "Run legacy rules in the saved environment": "运行旧规则同条件对照",
  "Eight saved legacy rule bundles and four current alternatives share one data interval and funding environment. This compares complete rule bundles; it is not a single-factor optimization.": "八组保存的旧规则，与当前 6%、8%、合格库存出售及组合方案，在同一数据、资金和理财环境中重跑。这是整套规则对照，不是单项参数优化。",
  "Frozen environment source": "冻结环境来源",
  "Legacy study source": "旧规则来源",
  "Return and drawdown frontier": "收益与回撤的非支配方案",
  "No other executed strategy in this environment has both an equal or higher return and an equal or lower drawdown with at least one strict improvement. This does not select a live strategy; cash-only outcomes are excluded.": "同一环境内，没有其他已执行波段的方案同时满足收益不低、回撤不高且至少一项更好。这只是历史收益与回撤比较，不自动选定实盘策略；仅现金收益结果不参与。",
  "Legacy rules: Fixed periods, thresholds and fractions": "旧规则：固定周期、门槛与比例",
  "Pressure environment: Legacy rules: Fixed periods, thresholds and fractions": "压力环境：旧规则：固定周期、门槛与比例",
  "Legacy rules: Dynamic thresholds only": "旧规则：仅动态门槛",
  "Pressure environment: Legacy rules: Dynamic thresholds only": "压力环境：旧规则：仅动态门槛",
  "Legacy rules: Dynamic quantities only": "旧规则：仅动态数量",
  "Pressure environment: Legacy rules: Dynamic quantities only": "压力环境：旧规则：仅动态数量",
  "Legacy rules: Dynamic periods only": "旧规则：仅动态周期",
  "Pressure environment: Legacy rules: Dynamic periods only": "压力环境：旧规则：仅动态周期",
  "Legacy rules: Dynamic thresholds and quantities": "旧规则：动态门槛与数量",
  "Pressure environment: Legacy rules: Dynamic thresholds and quantities": "压力环境：旧规则：动态门槛与数量",
  "Legacy rules: Dynamic thresholds and periods": "旧规则：动态门槛与周期",
  "Pressure environment: Legacy rules: Dynamic thresholds and periods": "压力环境：旧规则：动态门槛与周期",
  "Legacy rules: Dynamic quantities and periods": "旧规则：动态数量与周期",
  "Pressure environment: Legacy rules: Dynamic quantities and periods": "压力环境：旧规则：动态数量与周期",
  "Legacy rules: Dynamic thresholds, quantities and periods": "旧规则：动态门槛、数量与周期",
  "Pressure environment: Legacy rules: Dynamic thresholds, quantities and periods": "压力环境：旧规则：动态门槛、数量与周期",
  "Pressure environment: P1: 6% buy allocation": "压力环境：P1：买入比例 6%",
  "Pressure environment: P1: 8% buy allocation": "压力环境：P1：买入比例 8%",
  "Pressure environment: P3: 8% with profitable inventory sizing": "压力环境：P3：8%＋合格库存出售",
  "Pressure environment: Combined recovery and inventory experiment": "压力环境：恢复与出售节奏组合验证",
  "Six single-variable trading-rule experiments": "六组单变量买卖规则实验",
  "Independent two-sided funding preparation study": "独立双侧资金准备研究",
  "Run six trading-rule experiments": "运行六组买卖规则实验",
  "Run independent funding preparation study": "运行独立资金准备实验",
  "A1: 6% with profitable inventory sizing": "A1：6%＋合格库存出售",
  "B1: legacy dynamic quantity, 75% buy allocation": "B1：旧仅动态数量，买入比例降至原值 75%",
  "B2: legacy dynamic quantity, 50% buy allocation": "B2：旧仅动态数量，买入比例降至原值 50%",
  "B3: legacy dynamic quantity, profitable inventory sizing": "B3：旧仅动态数量＋合格库存出售",
  "C1: legacy dynamic period, 75% buy allocation": "C1：旧仅动态周期，买入比例降至原值 75%",
  "C2: legacy dynamic period, 50% buy allocation": "C2：旧仅动态周期，买入比例降至原值 50%",
  "Simple 40% initial TRX allocation": "初始 40% 本金买入 TRX 后持有",
  "Simple 70% initial TRX allocation": "初始 70% 本金买入 TRX 后持有",
  "Stablecoin redemption 60 minutes; TRX 1 minute": "稳定币赎回 60 分钟，TRX 1 分钟",
  "TRX redemption 60 minutes; stablecoins 1 minute": "TRX 赎回 60 分钟，稳定币 1 分钟",
  "Both sides redeem in 60 minutes": "双侧赎回均为 60 分钟",
  "Half APR, restricted quotas, both sides redeem in 60 minutes": "利率减半、额度收紧、双侧赎回 60 分钟",
  "From initial cash": "从初始现金开始",
  "After 90 continuous days": "连续回放第 90 天后切换",
  "Ordinary funding reproduction control": "普通资金环境精确复现控制",
  "Bounded funding preparation": "有界资金准备",
  "Original funding control": "原资金调度控制",
  "Continuous principal occupation and exposure": "全年连续本金占用与仓位",
  "Mean underwater principal cost": "全年平均亏损本金成本占用",
  "Peak underwater principal cost": "全年峰值亏损本金成本占用",
  "Mean principal cost held over 30 days": "全年平均持有超 30 天本金成本",
  "Peak principal cost held over 30 days": "全年峰值持有超 30 天本金成本",
  "Earn value change (USDT)": "理财收益变化（USDT）",
  "Funding conditions used for this result": "本次资金准备研究条件",
  "Ready funding hold minutes": "到账后最长等待分钟",
  "Funding cooldown minutes": "资金准备冷却分钟",
  "Continuous funding transition": "连续资金条件切换",
  "TRX research redemption delay override": "TRX 独立研究赎回等待",
  "An explicit TRX delay separates principal redemption from stablecoin redemption. An empty override inherits the general redemption delay.": "单独指定 TRX 本金的赎回等待，使其与稳定币资金分开；未指定时沿用一般赎回等待。",
  "Six predeclared single-variable rule changes use three reproduced sources and one frozen ordinary environment. Saved buy fractions and switches are retained.": "六组预先指定的单变量实验，使用三个精确复现来源和同一冻结普通环境；原买入比例及规则开关取自保存结果。",
  "Trading rules are frozen to legacy dynamic quantity. Each funding pair shares its environment; compare total equity, interest costs and drawdown within the pair. After 90 days, all lots, anchors, interest and pending funding continue without a reset.": "买卖规则冻结为旧仅动态数量，每组开关对照共用资金环境，按总权益、理财机会成本及回撤判断。第 90 天切换时，全部本金批次、锚点、利息和待到账资金连续继承，不重置账本。",
  "Underwater principal cost is capital tied to individual lots whose current sale proceeds after fees are below cost. It is not the loss amount. Old principal cost is sampled throughout the year, not only at the end.": "亏损本金成本占用按逐批扣除卖出费用后的市值低于成本计算，是被占用本金而非亏损金额。老仓成本按全年分钟记录统计，不只查看期末。",
  "Only a new confirmed signal may use arrived funding. Original signals keep their expiry, and every principal lot must still pass its net-profit check. Retained interest is excluded.": "资金实际到账后，必须出现新的确认信号才能交易；原信号不延寿，本金逐批复核净盈利，留存利息不参与普通出售。",
  "Frozen matched source batch": "冻结同条件来源批次",
  "The two study buttons use this source batch, independently of the selected detail.": "两条实验入口使用此批次的保存来源，独立于当前明细选择。",
  "The earlier parameter table describes the initial environment; this table describes conditions after the transition. Trading rules remain the same throughout.": "上方参数表记录初始环境，此处参数表记录切换后的环境；买卖规则全程保持一致。",
  "C_08": "C1 邻近检查：8% 买入比例",
  "C_10": "C1 邻近检查：10% 买入比例",
  "C1 neighbor: 8% buy allocation": "C1 邻近检查：8% 买入比例",
  "C1 neighbor: 10% buy allocation": "C1 邻近检查：10% 买入比例",
  "Candidate stability validation": "候选稳定性验证",
  "Run candidate stability validation": "运行候选稳定性验证",
  "C1 neighborhood: 8%, 9%, 10%; saved 6% and 12% context": "C1 邻近检查：8%、9%、10%；保留原 6%、12% 对照",
  "Normal one-minute redemption: preparation enabled / disabled": "普通一分钟赎回：资金准备开启／关闭",
  "After 180 continuous days": "连续回放第 180 天后切换",
  "C1 improvement from the complete continuous ledgers": "完整连续账本中的 C1 改善来源",
  "C1 minus old period source, USDT": "C1 减原旧周期来源，USDT",
  "Old period source: 12%": "原旧周期来源：12%",
  "C1: 9%": "C1：9%",
  "Realized principal profit after costs": "本金已实现净利润",
  "Ending principal mark after costs": "期末本金浮盈亏",
  "TRX interest at credited prices": "TRX 利息到账时估值",
  "Retained TRX interest price PnL": "留存 TRX 利息价格损益",
  "Realized FX profit after costs": "已实现兑换净损益",
  "Ending FX mark after costs": "期末兑换浮盈亏",
  "Principal profit already includes credited fee rebates and execution costs. Do not subtract costs again. Ending marks are separate from completed principal sales.": "本金盈亏已包含到账返费和执行成本，不能再次扣除。期末估值与已成交本金销售净利润分别列示。",
  "Only 8% and 10% are new rule parameters. The 6%, 9% and 12% rows reuse saved full ledgers. Funding independently uses old dynamic quantity, with one-minute and day-180 both-60 pairs. Hold 240 minutes, cooldown 60 minutes; no account reset or activation.": "仅新增 8%、10% 两个买入比例；6%、9%、12% 使用已保存的完整连续账本。资金线独立使用旧仅动态数量，补普通一分钟赎回和第 180 天双侧 60 分钟赎回的开启／关闭对照。保留 240 分钟、冷却 60 分钟，不重置或启动账户。",
  "Same-calendar continuous paths": "同一日历区间的连续路径",
  "Contribution": "收益贡献",
  "Change (USDT)": "变化（USDT）",
  "Charts use hourly samples; the download preserves every minute. Monthly accounts inherit all positions and retained interest. First and last months are partial; monthly calendar is Asia/Shanghai.": "图表按小时展示，下载保留每一分钟。月度账户连续继承本金和留存利息；首尾月份不完整，月度日历采用北京时间。",
  "Ending equity gap (USDT)": "月末权益差（USDT）",
  "Monthly change in gap (USDT)": "当月权益差变化（USDT）",
  "Download aligned minute paths": "下载同日期分钟路径",
  "Download monthly attribution": "下载月度归因",
  "Download actual batch differences": "下载实际批次差异",
  "Download full attribution": "下载完整归因",
  "Normal funding enabled/control: full minute paths and Earn operations identical; preparation events": "普通环境开启／关闭：全年分钟路径和理财操作一致；资金准备事件",
  "minute rows": "分钟记录",
  "Day-180 pair inherits identical held principal, anchors and retained interest.": "第 180 天成对回放继承相同的本金、锚点和留存利息。",
  "Funding preparation": "资金准备",
  "Return since the switch": "切换后区间收益",
  "Maximum drawdown since the switch": "切换后区间最大回撤",
  "Mean TRX exposure since the switch": "切换后平均 TRX 仓位",
  "Buy / sell fills since the switch": "切换后买／卖成交笔数",
  "After day 180, measure the shared window separately. Identical annual maximum drawdown can conceal different risk after the switch.": "第 180 天后单独比较同一窗口。全年最大回撤相同，也可能掩盖切换后风险不同。",
  "C2: 6%": "C2：6%",
  "Selected detail result": "当前明细结果",
  "Frozen C1 source batch": "冻结的 C1 来源批次",
  "The validation uses saved ledgers independently of the selected detail result.": "本次验证使用保存的完整账本，与当前明细结果独立。",
  "Equity": "账户权益",
  "Frozen candidates across continuous history": "冻结候选的跨区间连续验证",
  "Replay the frozen cross-period protocol": "按冻结协议重放跨区间验证",
  "Current eligible inventory sale: 8%": "当前合格库存出售：8%",
  "Legacy dynamic quantity": "旧仅动态数量",
  "Longer history with a continuously inherited account": "更长历史：连续继承账户",
  "Exact reproduction from the saved original start": "原起点：精确复现控制",
  "Real historical prices plus frozen Earn conditions; historical actual product returns are not reconstructed. Four saved candidates, no funding preparation, no calendar account reset.": "真实历史价格＋冻结理财条件的研究情景，未还原历年真实产品收益。四个候选均取保存参数，不加入资金准备，不按日历重启账户。",
  "Coverage determined before new strategy results": "在查看新策略结果前确定的覆盖区间",
  "Synthetic candles": "合成 K 线",
  "Original-start controls must reproduce exactly. Earlier-start inherited accounts have different lots, costs and anchors and need not reproduce the old annual return. Original PRD defaults and the paused account remain unchanged.": "原起点控制须精确复现。更早起点继承的批次、成本和锚点不同，不要求重复原年度收益；原 PRD 默认规则和暂停账户保持原状态。",
  "Continuous paths, calendar periods and retained-interest risk": "连续路径、月年切片与留存利息风险",
  "Long-history charts use daily display points; risk and period statistics use every minute. All calendar periods inherit the same account.": "长历史图表按日抽样展示，风险和区间统计使用全部分钟记录。所有月、年报表继承同一个账户。",
  "Minutes at TRX exposure at least 80%": "TRX 仓位至少 80% 的分钟数",
  "Longest continuous high-exposure minutes": "最长连续高仓位分钟数",
  "Mean retained-interest exposure": "平均留存利息敞口",
  "Maximum retained-interest exposure": "最大留存利息敞口",
  "Ending retained-interest exposure": "期末留存利息敞口",
  "Continuous calendar slices": "连续账户日历切片",
  "Period returns use actual inherited opening equity. Drawdown is measured within the calendar window; account state is never reset. Partial first and last periods remain visible.": "区间收益以真实继承的期初权益计算，回撤在相同日历窗口内测量，账户状态不重置。首尾不完整月年仍展示。",
  "Long-history charts use daily display points; downloads preserve every minute. Passive accounts use the same frozen conditions and remain continuous.": "长历史图表按日抽样，下载保留每一分钟；被动账户采用相同冻结环境并保持连续。",
  "Original calendar year with inherited positions": "原年度日历窗口：继承老仓后的表现",
  "Inherited opening equity": "继承的期初权益（USDT）",
  "Inherited principal cost": "继承的本金成本（USDT）",
  "Inherited TRX interest": "继承的 TRX 利息数量",
  "Inherited anchor": "继承的共用锚点",
  "Download inherited calendar audit": "下载继承账户的日历对照",
  "Download month-end equity gaps": "下载月末权益差",
  "Download calendar periods": "下载日历切片",
  "Default candle data": "默认行情",
  "Extreme historical candles and execution evidence require review": "极端历史行情与成交假设待核验",
  "Official extreme candles were reproduced. C1 modeled a large purchase in a zero-volume minute at an extreme low price; historical depth and executability are unconfirmed. This return cannot establish its high-return priority.": "官方接口重查复现了极端行情。C1 曾在零成交量分钟按极端低价模拟大额买入，历史深度与可成交性尚未确认，不能凭本轮收益提高其高收益路线优先级。",
  "C1 tagged batch realized profit after credited rebates": "C1 标记批次已实现净利润（含到账返佣）",
  "Share of realized principal profit": "占全部本金已实现利润",
  "This is attribution within the preserved account path. No trades or candles were deleted; subtracting the tagged profit cannot reproduce a path without that purchase.": "这是原连续路径内的归因，未删除交易或行情。直接减去该笔利润，不能得到没有这笔买入的账户路径。",
  "Download price and execution audit": "下载行情与成交核验",
  "Cumulative return": "累计收益率",
  "Full-period continuous principal occupation and exposure": "全期连续本金占用与仓位",
  "Capital occupation is cost tied to remaining lots, not loss. Old principal is sampled across the full continuous path, not only at the end.": "本金占用是留存批次的成本，不是亏损金额；老仓成本按整段连续路径的分钟记录统计，不只查看期末。",
  "Yearly": "年度",
  "Monthly": "月度",
  "Ending equity": "期末权益",
  "C1 zero-Earn comparison across 1, 2, 3 and 5 years": "C1 零理财：1／2／3／5 年区间对比",
  "C1 fixed-APR comparison with free 1:1 FX": "C1 理财：1／2／3／5 年区间对比，USDT↔USDGO 1:1",
  "Matched zero-Earn return": "同区间零理财收益",
  "USDGO interest credited": "USDGO 已到账利息",
  "Same-scenario TRX buy-and-hold return": "同理财情景持有 TRX 收益",
  "Each start has 1,000 USDT and zero TRX. C1 rules and trading costs are frozen; TRX, USDT and USDGO Earn are disabled. Each account remains continuous within its own window.": "每个起点均为 1,000 USDT、0 TRX。C1 买卖规则及交易成本冻结，关闭 TRX、USDT、USDGO 理财；每组账户在自己的区间内连续运行。",
  "Common endpoint": "统一结束时点",
  "Different durations and opening states: cumulative returns are not a same-period strategy ranking. Annualized return uses actual elapsed time and does not mean every year earned that rate.": "各组时长、起点和后续持仓不同，累计收益不能作为同区间策略排名。复合年化按实际时长计算，不代表每年都取得这一收益。",
  "Annualized return (CAGR)": "复合年化收益",
  "Zero-Earn TRX buy-and-hold return": "同区间持有 TRX 收益",
  "{years}-year C1 without Earn": "{years} 年 C1（零理财）",
  "Reused saved one-year result": "复用已保存的 1 年结果",
  "Profits use each saved snapshot’s fees, credited rebates and slippage. Ending TRX stays marked to market without forced liquidation. The passive return uses the same window and costs. Reused results are marked individually.": "利润按各自快照的手续费、到账返佣与滑点计算。期末 TRX 按市值计入，不强制清仓。持有基准使用相同区间和费用口径；复用结果会逐行标明。",
  "Profits include original fees, credited rebates and slippage. Ending TRX stays marked to market without forced liquidation. The passive return uses the same window and zero-Earn costs. The one-year row reuses the completed result.": "利润已计入原手续费、到账返佣与滑点。期末 TRX 按市值计入，不强制清仓。持有基准使用相同区间和零理财费用口径；1 年行复用刚完成的结果。",
  "C1: 1 years without Earn": "C1：1 年零理财",
  "C1: 2 years without Earn": "C1：2 年零理财",
  "C1: 3 years without Earn": "C1：3 年零理财",
  "C1: 5 years without Earn": "C1：5 年零理财",
  "Ending principal unrealized PnL": "期末本金浮盈亏",
  "TRX scenario APR": "TRX 情景年化利率",
  "USDGO scenario APR": "USDGO 情景年化利率",
  "USDT scenario APR": "USDT 情景年化利率",
  "TRX interest-bearing cap": "TRX 计息额度",
  "USDGO interest-bearing cap": "USDGO 计息额度",
  "USDGO mark in USDT": "USDGO 估值汇率",
  "FX conversion fee": "稳定币兑换手续费",
  "FX bid-ask spread": "稳定币兑换买卖价差",
  "FX conversion slippage": "稳定币兑换滑点",
  "Strategy and values saved for this run": "本次策略与参数快照",
  "Strategy actually run": "本次实际运行策略",
  "Saved mechanism combination": "快照中的机制组合",
  "Snapshot result ID": "快照结果编号",
  "Rule version": "规则版本",
  "This result belongs to one strategy run. The values below come from its saved snapshot.": "本结果只对应一套策略，下面展示该次运行保存的快照值。",
  "Dynamic thresholds": "动态门槛",
  "Dynamic confirmation periods": "动态确认周期",
  "Not recorded in this snapshot": "本快照未记录",
  "Full saved parameter snapshot": "完整参数快照（本次保存值与生效状态）",
  "TRX, USDT and USDGO Earn are all off. Any APR or savings settings retained in this snapshot do not contribute income to this run.": "TRX、USDT、USDGO 理财均关闭。快照中仍保留的利率和申赎设置，在本次回测中不参与理财收益计算。",
  "Every value below comes from the selected result snapshot. Missing historical fields are not filled with today’s defaults.": "以下值均来自当前选中结果的保存快照，历史记录缺失的字段不补入当前默认值。",
  "Earn is disabled; this saved setting is not used in this run.": "本次关闭理财，该保存值不参与本次运行计算。",
  "Snapshot identification": "快照标识或出处",
  "Recorded; applicability not documented": "已记录，适用性尚未说明",
  "Not used in this run": "本次不参与计算",
  "Inherited from strategy: enabled": "沿用本次策略：开启",
  "Inherited from strategy: disabled": "沿用本次策略：关闭",
  "Used by this run": "本次使用",
  "Saved snapshot value": "本次快照保存值",
  "Status in this run": "本次生效状态",
  "General variant reference, separate from this run": "通用版本说明（与本次运行分开）",
  "The following is general documentation about other strategy variants. It is not a list of strategies executed by this result.": "以下是其他策略版本的通用适用范围说明，不代表本次结果执行了这些版本。",
  "Original saved snapshot fields": "原始快照字段（只读）",
  "This run further adjusts the saved buy fraction using dynamic buy sizing.": "本次开启动态买入数量，会在保存的基础比例上进一步调整预算。",
  "This run uses the saved fixed buy fraction; available cash, fees and market minimums still apply.": "本次使用保存的固定买入比例，仍受可用现金、手续费和最小订单限制。",
  "This run further adjusts the saved sell fraction using dynamic sell sizing.": "本次开启动态卖出数量，会在保存的基础比例上进一步调整出售数量。",
  "This run uses the saved fixed sell fraction with its saved inventory basis; profitable-lot selection and tail completion still apply.": "本次按保存的固定卖出比例及库存口径计算目标数量，仍逐批检查盈利并处理符合条件的尾仓。",
  "Candidate periods": "候选确认周期",
  "Saved sell confirmation ceiling": "本次保存的卖出确认周期上限",
  "Replay-only sell confirmation ceiling; the original dynamic buy scheduling rule and shared transaction anchor are retained.": "本次研究单独限制卖出确认周期；买入保留原动态周期规则，成交后仍沿用共用锚点。",
  "Buy fee rate": "买入手续费率",
  "Sell fee rate": "卖出手续费率",
  "TRX hourly interest only": "仅 TRX 小时理财",
  "Fee rebate ratio": "手续费返佣比例",
  "Slippage": "交易滑点",
  "Half USDGO and half TRX at the first open": "首分钟开盘半仓 USDGO、半仓 TRX",
  "Startup allocation budgets": "启动分配预算",
  "Buy fee included": "含买入手续费",
  "Wait and Small initial purchase establish their first anchor after warmup. Half-position startup converts half the budget to USDGO and buys TRX with the other half at the first minute open; ordinary signals still wait for warmup.": "等待回撤和先买少量在预热后建立首次锚点；半仓启动在首分钟开盘把一半预算兑换 USDGO，另一半买入 TRX，普通信号仍等待原有预热完成。",
  "The startup buy budget as a fraction of deployable capital, including its fee. Small initial purchase executes after warmup; Half-position startup fixes this at 50% and executes at the first open.": "启动买入预算占可部署本金的比例，预算包含手续费。先买少量在预热后执行；半仓启动固定为 50%，在首分钟开盘执行。",
  "Condition: startup uses an initial purchase; half-position mode fixes it at 50%.": "条件：启动方式为先买少量或半仓启动；半仓启动固定为 50%。",
  "Initial purchases bypass ordinary dynamic buy sizing. Half-position startup fixes this fraction at 50% and the remaining budget goes to USDGO; small purchases use their saved fraction after warmup.": "首次买入不使用普通动态买入因子。半仓启动固定为 50%，另一半预算兑换 USDGO；先买少量在预热后使用快照保存的首次比例。",
  "Half-position startup uses the cash net-benefit hourly model. Half the initial budget goes to USDGO; the other half buys TRX at the first minute open with its fee included. Ordinary signals retain their volatility warmup. This startup is for historical replay only.": "半仓启动使用现金净收益小时模型。一半初始预算兑换 USDGO，另一半在首分钟开盘买入 TRX，预算包含买入手续费；普通信号仍保留原有波动预热。此启动方式目前用于历史回测。",
  "Price-position sizing": "价位调节",
  "Price reference lookback": "价位参考窗口",
  "Price reference quantile": "价位参考分位数",
  "High-price buy multiplier": "高价区买入系数",
  "High-price sell multiplier": "高价区卖出系数",
  "Complete Beijing days": "个完整北京时间日",
  "Price-position research rules": "价位调节研究规则",
  "The reference is updated at Beijing midnight using only previous complete days. A signal price strictly above it scales the original sizing target; other prices and insufficient history keep the original target. Startup allocation is excluded; profitable-lot and order limits still apply.": "参考价在北京时间每日零点更新，只使用此前完整日。信号价格严格高于参考价时，才对原目标数量乘系数；其余价格及历史不足时沿用原规则。初始建仓不参与调节，盈利批次和下单限制继续生效。",
  "Enables a separate daily causal price-position sizing layer. It changes ordinary order sizes, never signal thresholds or the startup allocation.": "独立开启每日价位调节，只改变普通订单规模，不改变信号门槛和初始建仓分配。",
  "Counts previous complete Beijing calendar days. Every minute close in those days has equal weight; missing history leaves original sizing unchanged.": "统计此前完整北京时间日的全部分钟收盘价，每分钟等权；历史不足时沿用原数量规则。",
  "The selected quantile of prior minute closes. Updated only at Beijing midnight; a price equal to the reference is outside the high-price region.": "此前分钟收盘价的指定分位数，只在北京时间零点更新；价格等于参考价时不进入高价区。",
  "Multiplies the original buy budget after any dynamic quantity formula when the signal close is strictly above the daily reference.": "信号收盘价严格高于每日参考价时，在原动态数量公式计算完毕后，对买入预算乘此系数。",
  "Multiplies the original sell share after any dynamic quantity formula. The saved sell cap, available principal and profitable-lot checks still apply.": "在原动态数量公式计算完毕后，对卖出比例乘此系数；仍受快照卖出比例上限、可用本金和盈利批次检查约束。",
  "Values are read from this result snapshot. This independent research layer does not replace the original dynamic threshold, quantity or period switches.": "读取本结果保存的参数。价位调节为独立研究开关，不替代原动态门槛、数量或周期开关。",
  "Price-position sizing is disabled in this saved result.": "本结果的价位调节已关闭。",
  "Condition: price-position sizing is enabled; sufficient prior complete days are available.": "适用条件：价位调节已启用，且已有足够的此前完整日数据。",
  "Sale execution policy": "卖出执行方式",
  "Proportional principal sales": "按本金库存比例卖出",
  "Whole recent profitable added lot, then proportional core": "新增盈利批次整笔优先，清空后按比例卖底仓",
  "Each sell signal targets one newest profitable added lot remaining quantity, without the P75 sell multiplier. Startup inventory is core. Any remaining added lot, including unprofitable lots or dust, blocks core sales; a later signal with no added lots sells core proportionally. Shared anchors, confirmation periods, fees and profit checks remain; retained TRX interest is excluded.": "每个卖出信号只卖最近一个合格新增批次的实际剩余数量，不乘 P75 高价区卖出系数。初始建仓属于底仓；只要新增批次还有余额（包括亏损批次或碎仓），就不按比例卖底仓。全部新增批次售完后，后续信号才按原比例卖底仓。共用锚点、确认周期、手续费和盈利检查保留，不出售留存 TRX 利息。",
  "Proportional uses the original principal sale fraction. Recent-lot mode targets one newest profitable added lot in full; any remaining added lot blocks proportional core sales.": "比例模式使用原本金库存比例；新增批次优先模式每次以最近一个合格新增批次的全部剩余数量为目标。存在任何新增批次余额时，暂停底仓比例卖出。",
  "Added-lot quantities bypass the P75 sell multiplier and never include core or retained interest. After all added lots are sold, later signals use the original core fraction. Shared anchors and profit checks are unchanged.": "新增批次数量不乘 P75 卖出系数，不混入底仓或留存利息。新增批次全部售完后，后续信号沿用底仓原比例；共用成交锚点和盈利检查不变。",
  "Inactive: size follows the target allocation gap": "未使用：按目标仓位差额计算数量",
  "Target allocation gap, profitable principal only": "按目标仓位差额卖出，仅限盈利本金",
  "Not used: price-touch research, no candle confirmation": "不适用：价格触及研究，不等待 K 线收盘确认",
  "Saved price-event research rules": "本次保存的到价交易研究规则",
  "The execution and sizing research below overrides the corresponding legacy settings. Minute paths and full limit fills are assumptions, not recovered ticks or verified live fills.": "本研究的实际成交与数量规则以下方保存值为准，相关原参数不参与决策。分钟内顺序和限价足额成交均为假设，并非已还原的逐笔行情或已验证的实盘成交。",
  "Research execution model": "研究成交模型",
  "Pre-funded resting limit orders": "预备资金后提前挂限价单",
  "Minute touch then next eligible open": "分钟内触价，随后在可执行分钟开盘成交",
  "Research sizing model": "研究数量规则",
  "Original 12% proportional sizing": "原买入／卖出基础比例 12%",
  "Linear target allocation within +/-30%": "±30% 区间线性目标仓位",
  "Progressive target allocation within +/-30%": "±30% 区间渐进目标仓位（平方曲线）",
  "Assumed intraminute path": "假设的分钟内价格顺序",
  "Fixed allocation center": "固定区间中心价",
  "Never reset after fills": "成交后不重设区间中心",
  "Allocation range and endpoint targets": "仓位区间与边界目标",
  "TRX target 100% to 0%; profitable-lot restrictions take precedence": "TRX 目标由 100% 至 0%；盈利批次限制优先",
  "Additional limit penetration": "限价成交额外穿价条件",
  "Saved execution constraint: no fills on zero-volume minutes. Positive full-bar volume is a simulation availability assumption, not proof of open-time liquidity.": "本次保存的撮合约束：零成交量分钟不成交。整分钟正成交量只是模拟可成交性假设，不能证明开盘时有足够流动性。",
  "Underlying C1 mechanism parameters": "底层 C1 开关参数（实际研究规则见下方）",
  "Saved TRX fraction at the first open; remainder to USDGO": "首分钟开盘按快照比例买入 TRX，剩余预算兑换 USDGO",
  "At the first minute open, the saved initial fraction buys TRX including its fee; the remaining initial budget converts to USDGO. Ordinary signals retain their warmup.": "首分钟开盘按保存的首次比例买入 TRX，预算含手续费；剩余初始预算兑换 USDGO，普通信号保留原有预热。",
  "This replay uses the recorded startup fraction. It does not change the ordinary buy or sell fractions and is not a permanent position target.": "本次回放使用快照记录的首次建仓比例，不改变后续基础买卖比例，也不是持续仓位目标。",
  "Condition: saved first-open allocation startup.": "条件：按保存比例在首分钟开盘分配初始资金。",
  "Real account · read only": "真实账户 · 只读",
  "Real account": "真实账户",
  "Bitget real account": "Bitget 真实账户",
  "Account reads and strategy execution have separate controls.": "账户查询与自动策略分别控制；读取账户不会启动交易。",
  "Account queries show raw exchange assets. Strategy allocation, cost basis and profit are shown in the C1 ledger below.": "账户查询展示交易所原始资产；策略划拨资金、持仓成本和收益以下方 C1 策略账本为准。",
  "A successful read verifies data access only. Actual trading, Earn writes and arrival reconciliation still require live validation.": "读取成功只证明此项数据可访问；真实成交、理财申赎及到账对账仍需实盘验收。",
  "Real account equity and holdings": "真实账户 · 权益与持仓",
  "Observed spot equity (USDT)": "已观测现货权益（USDT）",
  "Spot TRX quantity": "现货 TRX 数量",
  "Spot USDGO quantity": "现货 USDGO 数量",
  "Spot valuation quotes": "现货估值行情",
  "Spot holdings": "现货持仓",
  "Savings holdings · 90-day creation window": "理财持仓（近90天创建）",
  "Native holding quantities": "持仓数量走势（本币）",
  "Observed spot equity values USDT, USDGO and TRX only, including frozen and locked spot balances. TRX and USDGO use fresh exchange bid quotes; USDGO is not assumed to equal USDT. Savings and UTA assets are excluded from this equity.": "现货权益仅估值 USDT、USDGO、TRX，包含现货冻结及锁定余额。TRX 和 USDGO 按交易所新鲜买一价折算，不假设 USDGO 与 USDT 恒为 1:1；理财和 UTA 资产不并入此项权益。",
  "Each explicit account read records one local observation. History survives service restarts. These observations are not strategy profit; deposits, withdrawals and manual trades can change the curve.": "每次账户读取保存一个本地观测点，服务重启后保留。快照缺失或过期时，进入本页会自动读取一次；此曲线不是策略收益，充值、提现和手动交易均可能改变余额。",
  "Account chart history could not be read or saved. Current account tables remain separate.": "账户图表历史读取或保存失败，当前账户表格仍单独展示。",
  "No account chart observations yet. Click Connect and read account to record the first point.": "尚无账户图表观测记录。点击“连接并读取账户”后保存第一个点。",
  "This observation has no complete spot valuation. Missing balances or quotes stay blank; UTA equity is not treated as spot equity.": "本次观测无法完整估值现货权益：缺失余额或行情保留为空，UTA 权益不作为现货权益。",
  "Only one observation is available. The charts show points now; later account reads will build the curves. Earlier account history is not reconstructed.": "目前只有一个观测点，图中先显示圆点；后续读取逐步形成曲线，不反推此前的账户历史。",
  "Solid lines show spot quantities; dashed lines show returned Savings holdings from orders created in the last 90 days, which may omit older holdings. Product cumulative profit is not added again. Missing observations stay blank. Click legend entries to show or hide each line.": "实线为现货数量；虚线为接口返回的近90天创建订单的理财持仓，可能不含更早持仓。产品累计收益不重复叠加；缺失数据留空。点击图例可显示或隐藏各条线。",
  "The chart shows the latest 10,000 observations; older points remain stored locally.": "图表展示最近 10,000 个观测点，更早记录仍保存在本地。",
  "Bitget real account · read only": "Bitget 真实账户 · 只读",
  "Trading and Earn writes are disabled.": "实盘交易与理财申购、赎回均未启用。",
  "Account not connected": "未连接账户",
  "Invalid local configuration": "本地配置有误",
  "Account connection disabled": "账户连接已关闭",
  "Credentials configured; connection unverified": "凭据已配置，尚未验证连接",
  "Account read completed": "账户读取完成",
  "Account read partially completed": "账户部分读取完成",
  "Account read failed": "账户读取失败",
  "Account snapshot expired": "账户快照已过期",
  "All three credential fields are required from the same source.": "API Key、Secret Key、Passphrase 三项必须来自同一配置来源且填写完整。",
  "Check the local configuration format and supported fields.": "请检查本地配置的格式与支持字段。",
  "Set the private credential file permissions to 600.": "请将私密凭据文件权限设为 600。",
  "The API key lacks permission for this read.": "API Key 缺少此项读取权限。",
  "Bitget returned 40085: UTA accounts cannot use this Classic API. Check account type and API compatibility.": "交易所返回 40085：UTA 统一账户不支持此传统查询接口，请检查账户类型与接口兼容性。",
  "Authentication failed. Check credentials, IP restrictions and account type.": "鉴权失败，请核对凭据、IP 限制及账户类型。",
  "Bitget rate limit reached. Retry later.": "触发 Bitget 频率限制，请稍后重试。",
  "Bitget request timed out or the network is unavailable.": "Bitget 请求超时或网络不可用。",
  "The exchange response could not be verified.": "交易所响应未能通过校验。",
  "Pagination could not be completed. These holdings are unavailable.": "分页读取未完成，此部分持仓暂不可用。",
  "Duplicate exchange records detected. This section is unavailable.": "检测到重复交易所记录，此部分数据暂不可用。",
  "Duplicate asset rows detected. Balances are unavailable.": "检测到重复资产记录，余额暂不可用。",
  "The exchange returned an unexpected market. This section is unavailable.": "交易所返回了非预期市场，此部分数据暂不可用。",
  "Account balances": "账户余额",
  "Open TRX/USDT orders": "TRX/USDT 未成交订单",
  "Recent TRX/USDT fills": "TRX/USDT 近期成交",
  "UTA returns fills across spot markets. This page filters TRX/USDT from the latest 100 spot fills read; other pairs are excluded.": "UTA 成交接口返回各现货交易对的记录。本页从本次读取的最新最多 100 条现货成交中筛选 TRX/USDT，其他交易对不并入；不能据此推定完整历史。",
  "Flexible Savings holdings": "活期理财持仓",
  "Current flexible products": "当前活期产品",
  "Read completed": "读取完成",
  "Read failed": "读取失败",
  "Unsupported for this account type": "此账户类型尚不支持",
  "Read disabled": "未启用读取",
  "Unable to read account status. Retry after checking the local service.": "无法读取账户状态，请检查本地服务后重试。",
  "Reload local connection status": "重读本地配置状态",
  "Connect and read account": "连接并读取账户",
  "Reading account…": "正在读取账户…",
  "This is an expired snapshot, not the current account balance. Read again to update it.": "此快照已过期，不能视为当前账户余额，请重新读取更新。",
  "Account assets are unassigned. No initial capital, cost basis or strategy profit is inferred.": "账户资产尚未分配给策略，不推定初始本金、持仓成本或策略收益。",
  "Read interval": "读取时间区间",
  "Snapshots expire after 60 seconds.": "快照超过 60 秒即标记过期。",
  "Local connection setup": "本地连接配置",
  "Copy config_examples/trx-bitget-readonly.example.json to the local path below and set permissions to 600.": "将 config_examples/trx-bitget-readonly.example.json 复制到下方本地路径，并将权限设为 600。",
  "Configure API Key, Secret Key and Passphrase locally. Never paste them into chat or browser storage.": "在本地配置 API Key、Secret Key 和 Passphrase，请勿粘贴到对话或浏览器存储中。",
  "Environment alternative: TRX_BITGET_API_KEY, TRX_BITGET_SECRET_KEY, TRX_BITGET_PASSPHRASE. Set all three and restart the backend.": "也可设置环境变量 TRX_BITGET_API_KEY、TRX_BITGET_SECRET_KEY、TRX_BITGET_PASSPHRASE，三项须一起设置，并重启后端。",
  "Classic and UTA use separate read APIs. UTA Savings support is not verified and remains disabled.": "经典账户与统一账户（UTA）使用各自的读取接口，UTA 理财支持尚未验证，保持关闭。",
  "Configured account type": "配置的账户类型",
  "Credential source": "凭据来源",
  "environment": "环境变量",
  "local_file": "本地文件",
  "none": "无",
  "Read verification": "读取核验",
  "A successful read verifies data access only. Strategy ownership, full asset reconciliation and live execution are pending.": "读取成功仅证明数据可访问；策略资产归属、完整资产对账和实盘执行仍待完成。",
  "UTA balances can share margin with derivatives. Available balance is not the C1 trading budget.": "UTA 余额可能与衍生品共用保证金，可用余额不能直接当作 C1 交易预算。",
  "Restricted available": "受限可用",
  "Account balance": "账户余额",
  "Account equity": "账户权益",
  "Debt": "负债",
  "Frozen": "冻结",
  "Locked": "锁定",
  "Only USDT, USDGO and TRX are shown. Missing currencies are not assumed to have zero balance.": "仅展示 USDT、USDGO 和 TRX，接口未返回的币种不推定为零余额。",
  "Only the latest 100 rows are shown. This is not a complete history or reconciliation.": "仅展示最近 100 条，不能视为完整历史或完整对账。",
  "No records returned in this query.": "本次查询范围内未返回记录。",
  "Order quantity": "委托数量",
  "Filled TRX": "已成交 TRX 数量",
  "Fees retain the exchange sign and original currency. Research rebates are not applied.": "手续费保留交易所返回的正负号和原币种，不套用研究返佣假设。",
  "Actual fee details": "实际费用明细",
  "BGB deduction": "BGB 抵扣",
  "Coverage: orders created in the last 90 days. Older holdings and redemption arrival remain unverified; this is not a full asset reconciliation.": "查询范围：近 90 天创建的订单。更早持仓及赎回到账尚未核查，不能视为完整资产对账。",
  "Holding quantity": "持仓数量",
  "Interest currency": "派息币种",
  "Product cumulative profit reported by API": "产品累计收益（接口值）",
  "Rates are read from the current API response. Personal quotas, subscription eligibility, FX quotes and redemption delays remain unverified.": "利率取自当前接口响应；个人额度、申购资格、兑换报价和赎回时效仍待核实。",
  "This account cannot use this read API. Compatibility remains unverified.": "此账户无法使用该查询接口，兼容性尚未确认。",
  "The savings record type, currency or timestamp did not match the query.": "理财流水类型、币种或时间与查询范围不符，此部分数据暂不可用。",
  "The exchange returned conflicting copies of one record. This section is unavailable.": "同一流水出现冲突内容，此部分数据暂不可用。",
  "The read time budget was reached. Reduce history days and retry.": "已达到本次读取时间上限，请缩短查询天数后重试。",
  "UTA funding account balances": "UTA 资金账户余额",
  "UTA trading account balances": "UTA 统一交易账户余额",
  "Funding account Savings entries": "资金账户活期理财流水",
  "Savings subscriptions, redemptions and interest": "活期申购、赎回与派息流水",
  "Read partially completed": "部分读取完成",
  "Not applicable to this account type": "此账户类型无需单独查询",
  "Savings read compatibility pending verification": "普通活期查询兼容性待验证",
  "Savings read access confirmed for this snapshot": "本次快照已确认普通活期查询可访问",
  "Savings read access partially confirmed": "普通活期查询仅部分确认可访问",
  "Savings read access could not be confirmed": "未能确认普通活期查询可访问",
  "Savings reads disabled": "普通活期查询已关闭",
  "Subscription record": "申购记录",
  "Redemption record · arrival unverified": "赎回记录 · 到账未核实",
  "Interest payment record": "派息记录",
  "Flexible subscription funding entry": "活期申购资金流水",
  "Flexible redemption funding entry": "活期赎回资金流水",
  "Flexible interest funding entry": "活期收益资金流水",
  "Savings read adaptation is implemented. UTA uses a Savings v2 compatibility read plus separate funding-account reads.": "普通活期只读适配已加入。UTA 将尝试读取 Savings v2，并单独查询资金账户；实际权限和产品可用性待联调确认。",
  "Classic account: spot and ordinary flexible Savings use the v2 read APIs. Check the verification results below for access status.": "当前为 Classic 经典账户：现货与普通活期理财使用 v2 查询接口。各项访问状态请查看下方读取核验结果。",
  "Ordinary Savings uses the documented v2 read APIs. UTA permissions and product access must be verified with your account; no On-chain Elite product is substituted.": "普通活期使用文档所列的 v2 查询接口。UTA 的访问权限和产品可用性需用实际账户验证，不以链上精选产品替代。",
  "Trading account, funding account and Savings holdings are separate observations. They are not summed into strategy equity.": "统一交易账户、资金账户和理财持仓分别展示，不直接合计为策略权益。",
  "Balance component difference": "余额分量差额",
  "Balance components need review": "余额分量需核查",
  "Product rates and available subscription-detail fields come from the current API response. Tier limits are not personal quotas. Read access does not verify subscription eligibility, FX quotes or actual redemption arrival.": "利率及可读取的申购详情取自当前接口。利率档位上限不等于个人额度；读取成功不代表已确认申购资格、兑换报价或实际赎回到账。",
  "Per-subscription minimum / maximum": "单笔申购最小／最大数量",
  "API remaining amount": "接口返回剩余额度",
  "Subscription precision": "申购小数位数",
  "API redemption delay": "接口返回赎回时效",
  "Not provided by API": "接口未提供",
  "Interest start / settlement time": "起息／结算时间",
  "Subscription detail has not been read.": "申购详情尚未读取（每次最多读取 12 个产品详情）。",
  "Savings and funding records may describe the same event. They are not added together or credited to the strategy ledger. A redemption record alone does not verify spendable arrival.": "理财流水和资金流水可能对应同一事件，不相加计收益，也不记入策略账本。仅有赎回记录不能证明资金已可用。",
  "Record type": "流水类型",
  "Product currency": "产品币种",
  "Settlement currency": "结算币种",
  "API record amount": "接口流水金额",
  "Native funding amounts retain their sign. Per-order redemption arrival remains unverified.": "资金流水保留接口原始正负号，逐笔赎回到账仍未核实。",
  "Balance change": "余额变化",
  "Balance after entry": "变动后余额",
  "Open USDGO/USDT orders": "USDGO/USDT 未成交订单",
  "Recent USDGO/USDT fills": "USDGO/USDT 近期兑换成交",
  "Order ID": "订单号",
  "Trade ID": "成交号",
  "Filled quantity": "已成交数量",
  "UTA returns fills across spot markets. TRX/USDT and USDGO/USDT are shown separately from the latest 100 spot fills read; other pairs are excluded.": "UTA 返回跨现货市场成交；TRX/USDT 与 USDGO/USDT 分别从最近 100 条现货成交中筛选，其他币对不展示。",
  "This product subscription detail is unavailable (59012). Product rates remain visible; eligibility is unverified.": "交易所未提供此产品的申购详情（59012）；利率仍可查看，申购资格尚未确认。",
  "Trading turnover": "成交额"
}
